import React, { useState, useEffect, useContext, useMemo, useRef } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import {
  Col,
  Row,
  Form,
  Button,
  FormGroup,
  Label,
  Input,
  Spinner,
  Modal,
  ModalHeader,
  ModalBody,
  Table,
  Badge,
} from "reactstrap";
import axios from "axios";
import Swal from "sweetalert2";
import Header from "../../../layout/Header/Header";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import moment from "moment";
import { v4 as uuidv4 } from "uuid";
import { epcToEAN13, validateEAN13 } from "../../../../utils/ean13Generator";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import qrcode from "qrcode-js";
import { encode } from "base64-arraybuffer";



function ApartadosTiendasCreate() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = import.meta.env.VITE_URL_LOGS;
  const URL_INVENTARIOS = import.meta.env.VITE_URL_INVENTARIOS;
  const URL_COLABORADORES = import.meta.env.VITE_URL_COLABORADORES;
  const URL_CLIENTES = import.meta.env.VITE_URL_CLIENTES;
  const URL_VENTAS_TIENDAS = import.meta.env.VITE_URL_VENTAS_TIENDAS;
  const URL_ARTICULOS_VENTAS_TIENDAS =
    import.meta.env.VITE_URL_ARTICULOS_VENTAS_TIENDAS;
  const URL_AREAS = import.meta.env.VITE_URL_AREAS;
  const URL_SEND_MAIL = import.meta.env.VITE_URL_SEND_MAIL;
  const URL_PAQUETERIAS = import.meta.env.VITE_URL_PAQUETERIAS;
  const URL_GRUPOS = import.meta.env.VITE_URL_GRUPOS;
  const URL_DEPARTAMENTOS_CLIENTES =
    import.meta.env.VITE_URL_DEPARTAMENTOS_CLIENTES;
  const URL_WHATSAPP = import.meta.env.VITE_URL_WHATSAPP;
  const URL_ARTICULOS_PROPORCION =
    import.meta.env.VITE_URL_ARTICULOS_PROPORCION;
  const URL_TALLAS = import.meta.env.VITE_URL_TALLAS;
  const URL_ANTICIPOS = import.meta.env.VITE_URL_ANTICIPOS;

  let date = new Date();
  let hoy = moment(date).format("YYYY-MM-DD");
  let hora = moment(date).format("HH:mm:ss");

  const [clientes, setClientes] = useState([]);
  const [colaboradores, setColaboradores] = useState([]);
  const [selectedColaborador, setSelectedColaborador] = useState("");
  const [selectedColaboradorName, setSelectedColaboradorName] = useState("");
  const [value, setValue] = useState("");

  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);

  const [tallas, setTallas] = useState([]);
  const [customSizeOrder, setCustomSizeOrder] = useState([]);

  const [expandedTables, setExpandedTables] = useState({});

  const [paqueterias, setPaqueterias] = useState([]);
  const [idPaqueteria, setIdPaqueteria] = useState("647e2090513ca00014b4edbc");
  const [inventarios, setInventarios] = useState([]);
  const [areas, setAreas] = useState([]);
  const [areaCliente, setAreaCliente] = useState("");
  const [selectedArea, setSelectedArea] = useState("");
  const [selectedAreaName, setSelectedAreaName] = useState("");
  const [comisionTDC, setComisionTDC] = useState(0);
  const [comisionFlete, setComisionFlete] = useState(0);
  const [articulosUnicos, setArticulosUnicos] = useState([]);

  const [fecha, setFecha] = useState(hoy);
  // Todo apartado es, por naturaleza, una venta a credito (anticipo parcial +
  // saldo pendiente). No existe un modo "Contado" aqui: eso forzaria a liquidar
  // el saldo completo al crear, que es justo lo que un apartado NO debe hacer.
  const [condPago, setCondPago] = useState("Credito");
  const [observaciones, setObservaciones] = useState("NA");
  const [total_general, setTotalGeneral] = useState(0);
  const [subTotal, setSubTotal] = useState(0);
  const [iva, setIva] = useState(0);
  const [total_cantidad, setTotalCantidad] = useState(0);
  const [selectedImpuesto, setSelectedImpuesto] = useState(0);
  const [alertasCliente, setAlertasCliente] = useState("No");
  const [listaPrecios, setListaPrecios] = useState(1);

  const [efectivo, setEfectivo] = useState(0);
  const [tdc, setTDC] = useState(0);
  const [transfer, setTransfer] = useState(0);
  const [fechaTransfer, setFechaTransfer] = useState("NA");
  const [destino, setDestino] = useState("NA");
  const [terminal, setTerminal] = useState("NA");
  const [fiscal, setFiscal] = useState("No");
  const [saldo, setSaldo] = useState(0);

  
  const [inputFields, setInputFields] = useState([]);

  const [manualInput, setManualInput] = useState({
    articulosNombre: "",
    articulos: "",
    idColor: "",
    idTalla: "",
    tallaNombre: "",
    cantInv: 0,
    cantidad: 0,
    colores: [],
    tallas: [],
    total: 0,
    idProporcion: "",
  });

  const [inputArticulos, setInputArticulos] = useState([
    {
      id: uuidv4(),
      articulos: "",
      cajas: 0,
      precio: 0,
      articulosNombre: "",
      colores: [],
      tallas: [],
    },
  ]);

  const [validaBoton, setValidaBoton] = useState(true);
  const submittingRef = useRef(false);
  // Llave de idempotencia del guardado: se conserva si la peticion no llego a
  // responder (reintento seguro) y se descarta si el servidor la rechazo.
  const codigoAgrupadoRef = useRef(null);

  // Anticipo del cliente: administracion lo registra en Admin -> Anticipos.
  // El agente solo ve si tiene o no, nunca montos.
  const [anticipoCliente, setAnticipoCliente] = useState({
    cargando: false,
    tieneAnticipo: false,
    requiereAnticipo: false,
  });
  const bloqueadoPorAnticipo =
    !!value?._id &&
    (anticipoCliente.cargando ||
      (anticipoCliente.requiereAnticipo && !anticipoCliente.tieneAnticipo));

  // Apartado pendiente: un cliente no puede traer dos apartados debiendo al
  // mismo tiempo. Nacio porque abrian otro con otro asesor y nadie se enteraba
  // de lo que ya debia. Cuenta en todas las tiendas, y los clientes de
  // mostrador quedan fuera (eso lo decide el backend).
  const [apartadoPendiente, setApartadoPendiente] = useState({
    cargando: false,
    pendiente: false,
    mensaje: "",
  });
  const bloqueadoPorPendiente = !!value?._id && apartadoPendiente.pendiente;

  useEffect(() => {
    const clienteId = value?._id;
    if (!clienteId) {
      setAnticipoCliente({ cargando: false, tieneAnticipo: false, requiereAnticipo: false });
      return;
    }
    let vigente = true;
    setAnticipoCliente((prev) => ({ ...prev, cargando: true }));
    axios
      .get(`${URL_ANTICIPOS}/disponibleApartado/${clienteId}`, {
        headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
      })
      .then((res) => {
        if (!vigente) return;
        setAnticipoCliente({
          cargando: false,
          tieneAnticipo: !!res.data?.tieneAnticipo,
          requiereAnticipo: !!res.data?.requiereAnticipo,
        });
      })
      .catch((err) => {
        console.log(err);
        if (!vigente) return;
        // Si la consulta falla no se bloquea aqui: el servidor vuelve a
        // validar el anticipo al guardar y rechaza si falta.
        setAnticipoCliente({ cargando: false, tieneAnticipo: false, requiereAnticipo: false });
      });
    return () => {
      vigente = false;
    };
  }, [value?._id]);

  useEffect(() => {
    const clienteId = value?._id;
    if (!clienteId) {
      setApartadoPendiente({ cargando: false, pendiente: false, mensaje: "" });
      return;
    }
    let vigente = true;
    setApartadoPendiente((prev) => ({ ...prev, cargando: true }));
    axios
      .get(`${URL_VENTAS_TIENDAS}ApartadoPendiente/${clienteId}`, {
        headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
      })
      .then((res) => {
        if (!vigente) return;
        const pendiente = !!res.data?.pendiente;
        setApartadoPendiente({
          cargando: false,
          pendiente,
          mensaje: res.data?.message || "",
        });
        // Se avisa de una vez, al elegir al cliente, para que no capturen toda
        // la mercancia y hasta el final se enteren de que no se puede.
        if (pendiente) {
          Swal.fire({
            icon: "warning",
            title: "Apartado pendiente",
            text: res.data.message,
          });
        }
      })
      .catch((err) => {
        console.log(err);
        if (!vigente) return;
        // Si la consulta falla no se bloquea aqui: el servidor vuelve a
        // revisarlo al guardar y rechaza si hay uno pendiente.
        setApartadoPendiente({ cargando: false, pendiente: false, mensaje: "" });
      });
    return () => {
      vigente = false;
    };
  }, [value?._id]);

  // Borrador automatico: guarda el avance en localStorage para que un
  // apartado a medias no se pierda si se cierra el navegador o se sale
  // accidentalmente de la pestaña (mismo patron que VentasTiendasCreate.jsx).
  const DRAFT_KEY = `apartado_tienda_${user._id}`;
  const restoredRef = useRef(false);
  const canSaveRef = useRef(false);
  // Campo de escaneo QR/RFID NO controlado: el navegador acumula los caracteres
  // del lector sin que React reescriba el value entre teclas (ver VentasTiendasCreate).
  const rfidScanRef = useRef(null);
  // Lectura RFID masiva: cada tag (EPC) es UNA pieza fisica.
  //  - epcLeidosRef: EPC -> idArticuloProporcion del renglon donde se conto.
  const epcLeidosRef = useRef(new Map());
  const [rfidStats, setRfidStats] = useState({
    leidas: 0,
    repetidas: 0,
    noEncontradas: 0,
  });
  // Para lecturas de etiqueta el aviso es un toast: un modal le quita el foco al
  // campo y las lecturas siguientes del lector se pierden.
  const alertaEscaneo = (esEtiqueta, opts) =>
    Swal.fire(
      esEtiqueta
        ? {
            toast: true,
            position: "top-end",
            icon: opts.icon,
            title: opts.text || opts.title,
            showConfirmButton: false,
            timer: 2500,
            timerProgressBar: true,
          }
        : opts
    );
  const [cambiarPrecio, setCambiarPrecio] = useState(false);

  const [modalCambiaPrecio, setModalCambiaPrecio] = useState(false);
  const toggleCambiaPrecio = () => setModalCambiaPrecio(!modalCambiaPrecio);
  const [password, setPassword] = useState("");

  const [mailAutEnviado, setMailAutEnviado] = useState(false);
  const [randomCambiaPrecio, setRandomCambiaPrecio] = useState(
    (Math.random() + 1).toString(36).substring(2)
  );

  // Crear Clientes
  const [vistaCliente, setVistaCliente] = useState(false);
  const [nombre_comercial, setNombreComercial] = useState("");
  const [razon_social, setRazonSocial] = useState("NA");
  const [RFC, setRFC] = useState("NA");
  const [calle, setCalle] = useState("NA");
  const [numero_ext, setNumeroExt] = useState("NA");
  const [numero_int, setNumeroInt] = useState("NA");
  const [delegacion, setDelegacion] = useState("NA");
  const [estado, setEstado] = useState("NA");
  const [pais, setPais] = useState("Mexico");
  const [cp, setCP] = useState(0);
  const [colonia, setColonia] = useState("NA");
  const [ciudad, setCiudad] = useState("NA");
  const [plazo, setPlazo] = useState(0);
  const [regFiscal, setRegFiscal] = useState("NA");
  const [telefono, setTelefono] = useState("1");
  const [email, setEmail] = useState("a@a.a");
  const [grupos, setGrupos] = useState([]);
  const [selectedGrupo, setSelectedGrupo] = useState("");
  const [departamentos, setDepartamentos] = useState([]);
  const [selectedDepartamento, setSelectedDepartamento] = useState("");
  const [selectedPaqueteria, setSelectedPaqueteria] = useState(
    "647e2090513ca00014b4edbc"
  );
  const [selectedAreaCliente, setSelectedAreaCliente] = useState("");
  const [selectedVendedorInput, setSelectedVendedorInput] = useState("");
  const [selectedVendedor, setSelectedVendedor] = useState("");
  // En cuanto se elige un vendedor a mano, ya nadie se lo cambia solo.
  const vendedorTocadoRef = useRef(false);
  // El vendedor de la sesion se propone una sola vez por carga de pantalla.
  const vendedorSesionRef = useRef(false);
  //
  // Los cuatro valores se mueven juntos: el id que se guarda, el id del combo,
  // el texto del combo y el nombre que se imprime en la cotizacion. Cuando se
  // separaban, la cotizacion salia a nombre de un vendedor y el apartado
  // quedaba guardado con otro. El texto se arma igual que el value de las
  // opciones del combo (sin trim), o el select se queda sin nada seleccionado.
  const aplicaVendedor = (colaborador) => {
    if (!colaborador) return;
    const nombre = colaborador.nombre + " " + colaborador.apellido;
    setSelectedColaborador(colaborador._id);
    setSelectedVendedor(colaborador._id);
    setSelectedVendedorInput([colaborador._id, nombre]);
    setSelectedColaboradorName(nombre);
  };

  // El apartado lo levanta la vendedora que esta atendiendo, no una cajera de
  // mostrador: en produccion quien captura ES el vendedor en 93% de los
  // apartados (contra 13% en las ventas de mostrador, donde hay cajeras
  // dedicadas que capturan lo de todo el mundo). Por eso aqui el combo
  // arranca con el vendedor de la sesion y en ventas no.
  //
  // Si quien tiene la sesion no esta dado de alta como colaborador no se
  // propone nada: entra el vendedor de la ficha del cliente al elegirlo, que
  // es como funcionaba esta pantalla antes de tener combo.
  //
  // Se marca como hecho aunque no haya match, para no volver a proponer nada
  // encima de lo que ya eligieron a mano.
  useEffect(() => {
    if (vendedorSesionRef.current) return;
    if (vendedorTocadoRef.current) return;
    if (colaboradores.length === 0) return;
    if (!user?.nombre) return;
    const normaliza = (t) => (t || "").trim().toUpperCase().replace(/\s+/g, " ");
    const yo = normaliza(user.nombre + " " + user.apellido);
    const colaborador = colaboradores.find(
      (c) => normaliza(c.nombre + " " + c.apellido) === yo
    );
    vendedorSesionRef.current = true;
    if (colaborador) aplicaVendedor(colaborador);
  }, [colaboradores.length, user]);

  const [observacionesCliente, setObservacionesCliente] = useState("NA");
  const [forma_pago, setFormaPago] = useState("Contado");
  const [descuentoCliente, setDescuentoCliente] = useState(0);

  const [areaUserName, setAreaUserName] = useState("");

  useMemo(() => {
    axios
      .get(`${URL_CLIENTES}Activos`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allClientes = res.data;
        setClientes(allClientes);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_AREAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allAreas = res.data;
        console.log("allAreas", allAreas);
        setAreas(allAreas);
      })
      .catch((err) => {
        console.log(err);
      });
   

    setAreaUserName(user.areaName);
    // Sin selectedColaborador: adentro no se lee, solo se escribe al elegir
    // cliente, y dejarlo aqui volvia a pedir clientes y areas completos cada
    // vez que cambiaba el vendedor.
  }, [user, selectedArea]);

  useEffect(() => {
    axios
      .get(URL_COLABORADORES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allColaboradores = res.data;
        setColaboradores(allColaboradores);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(URL_PAQUETERIAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allPaqueterias = res.data;
        setPaqueterias(allPaqueterias);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(URL_GRUPOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allGrupos = res.data;
        setGrupos(allGrupos);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(URL_DEPARTAMENTOS_CLIENTES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allDepartamentos = res.data;
        setDepartamentos(allDepartamentos);
      })
      .catch((err) => {
        console.log(err);
      });
       axios
      .get(URL_TALLAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allTallas = res.data;
        setTallas(allTallas);
        const customeSizeOrder = allTallas.map((t) => t.name);
        setCustomSizeOrder(customeSizeOrder);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  // Restaura el borrador guardado (si existe) al montar la pantalla.
  useEffect(() => {
    if (restoredRef.current) return;
    restoredRef.current = true;

    let draft = null;
    try {
      const saved = localStorage.getItem(DRAFT_KEY);
      if (saved) draft = JSON.parse(saved);
    } catch (e) {
      console.log("Error al leer borrador", e);
    }

    const tieneAvance =
      draft &&
      ((draft.inputFields && draft.inputFields.length > 0) || draft.value);

    if (!tieneAvance) {
      canSaveRef.current = true;
      return;
    }

    Swal.fire({
      title: "Apartado sin terminar",
      text: "Tienes un apartado en progreso. ¿Deseas continuar con él o empezar uno nuevo?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Continuar con el anterior",
      cancelButtonText: "Empezar uno nuevo",
      confirmButtonColor: "#28a745",
      cancelButtonColor: "#d33",
      allowOutsideClick: false,
      allowEscapeKey: false,
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        if (draft.fecha) setFecha(draft.fecha);
        if (draft.observaciones !== undefined) setObservaciones(draft.observaciones);
        if (draft.value) setValue(draft.value);
        if (draft.selectedColaborador) setSelectedColaborador(draft.selectedColaborador);
        if (draft.selectedColaboradorName) setSelectedColaboradorName(draft.selectedColaboradorName);
        // El borrador manda sobre el vendedor de la sesion: si retomaron un
        // apartado a medias, el vendedor que ya traia es el que vale.
        if (draft.selectedVendedorInput) {
          setSelectedVendedorInput(draft.selectedVendedorInput);
          setSelectedVendedor(draft.selectedVendedor || "");
          vendedorTocadoRef.current = true;
        }
        if (draft.idPaqueteria) setIdPaqueteria(draft.idPaqueteria);
        if (draft.selectedArea) {
          setSelectedArea(draft.selectedArea);
          // El borrador guarda el ID del almacen, pero NO el inventario: eso
          // solo lo cargaba jalaAlmacen al elegirlo a mano. Al refrescar, la
          // cotizacion volvia pero `inventarios` y `articulosUnicos` quedaban
          // vacios, asi que el buscador no ofrecia nada y el escaner no
          // encontraba ningun codigo: no se podian agregar mas productos.
          cargarInventarios(draft.selectedArea);
        }
        if (draft.areaCliente) setAreaCliente(draft.areaCliente);
        if (draft.listaPrecios) setListaPrecios(draft.listaPrecios);
        if (draft.alertasCliente) setAlertasCliente(draft.alertasCliente);
        if (draft.comisionTDC !== undefined) setComisionTDC(draft.comisionTDC);
        if (draft.comisionFlete !== undefined) setComisionFlete(draft.comisionFlete);
        if (draft.selectedImpuesto !== undefined) setSelectedImpuesto(draft.selectedImpuesto);
        if (draft.inputFields) setInputFields(draft.inputFields);
        if (draft.inputArticulos) setInputArticulos(draft.inputArticulos);
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        localStorage.removeItem(DRAFT_KEY);
      }
      canSaveRef.current = true;
    });
  }, []);

  // Guarda el borrador cada vez que cambia el avance (despues de decidir).
  useEffect(() => {
    if (!canSaveRef.current) return;
    try {
      const hayAvance =
        inputFields.some((f) => f.articulos || parseFloat(f.cantidad) > 0) || !!value;
      if (hayAvance) {
        localStorage.setItem(
          DRAFT_KEY,
          JSON.stringify({
            fecha,
            observaciones,
            value,
            selectedColaborador,
            selectedColaboradorName,
            selectedVendedor,
            selectedVendedorInput,
            idPaqueteria,
            selectedArea,
            areaCliente,
            listaPrecios,
            alertasCliente,
            comisionTDC,
            comisionFlete,
            selectedImpuesto,
            vistaCliente,
            inputFields,
            inputArticulos,
          })
        );
      } else {
        localStorage.removeItem(DRAFT_KEY);
      }
    } catch (e) {
      console.log("Error al guardar borrador", e);
    }
  }, [
    fecha, observaciones, value, selectedColaborador, selectedColaboradorName,
    selectedVendedor, selectedVendedorInput,
    idPaqueteria, selectedArea, areaCliente, listaPrecios, alertasCliente,
    comisionTDC, comisionFlete, selectedImpuesto, vistaCliente,
    inputFields, inputArticulos,
  ]);

  useEffect(() => {
    ActualizaTotales();
  }, [inputFields, ActualizaTotales]);

  const handleManualArticuloChange = (selectedArticulo) => {
    // Filter inventory for the selected article
    let inventario = inventarios.filter(
      (inv) => inv.idArticulo === selectedArticulo.idArticulo
    );

    let precioArt;
    if (listaPrecios == 1) {
      precioArt = selectedArticulo.lista1;
    } else if (listaPrecios == 2) {
      precioArt = selectedArticulo.lista2;
    } else if (listaPrecios == 3) {
      precioArt = selectedArticulo.lista3;
    } else if (listaPrecios == 4) {
      precioArt = selectedArticulo.lista4;
    }

    // Get unique tallas from inventory
    let tallas = inventario.reduce((acc, curr) => {
      if (!acc.includes(curr.talla)) {
        acc.push(curr.talla);
      }
      return acc;
    }, []);

    // Get unique colores from inventory
    let colores = inventario.reduce((acc, curr) => {
      if (!acc.includes(curr.color)) {
        acc.push(curr.color);
      }
      return acc;
    }, []);

    // Filter selectedArticulo.colores to only include colors present in inventory
    let coloresRed = selectedArticulo.colores.filter((c) =>
      colores.includes(c.name)
    );

    // Filter selectedArticulo.tallas to only include sizes present in inventory
    let tallasRed = selectedArticulo.tallas.filter((t) =>
      tallas.includes(t.name)
    );

    if (selectedArticulo) {
      setManualInput({
        articulos: selectedArticulo.idArticulo,
        articulosNombre: selectedArticulo.nombre,

        colores: coloresRed,
        precio: precioArt,
        idProporcion: "",
        tallas: tallasRed,
        idColor: "",
        idTalla: "",
        cantidad: 0,
      });
    }
  };
  const handleManualInputChange = (event) => {
    const { name, value } = event.target;

    setManualInput((prev) => {
      const updatedInput = {
        ...prev,
        [name]: value,
      };

      // If changing talla, update tallaNombre
      if (name === "idTalla") {
        const selectedTalla = prev.tallas.find((t) => t._id === value);
        updatedInput.tallaNombre = selectedTalla ? selectedTalla.name : "";
      }

      // Calculate total whenever cantidad changes
      if (name === "cantidad") {
        const selectedColor = manualInput.colores.find(
          (c) => c._id === manualInput.idColor
        );
        const selectedTalla = manualInput.tallas.find(
          (t) => t._id === manualInput.idTalla
        );
        updatedInput.cantidad = parseFloat(value);

        // Sin estas guardas, un color+talla sin existencia dejaba `inventario`
        // en undefined y leer .idProporcion lanzaba TypeError DENTRO del updater
        // de setManualInput, o sea en fase de render. Como la app no tiene
        // ErrorBoundary, React desmontaba el arbol completo: pantalla en blanco
        // y se perdian los articulos ya capturados, obligando a reiniciar el
        // apartado. Es el mismo fix que VentasTiendasCreate.jsx ya tenia desde
        // el commit a25c824 ("fix pantalla blanca") y que nunca se porto aca.
        if (selectedColor && selectedTalla) {
          const inventario = inventarios.find(
            (inv) =>
              inv.idArticulo === manualInput.articulos &&
              inv.color === selectedColor.name &&
              inv.talla === selectedTalla.name
          );

          if (!inventario || inventario.cantidad <= 0) {
            Swal.fire({
              icon: "error",
              title: "Sin existencia",
              text: "No hay existencia disponible para esta talla y color.",
              showConfirmButton: false,
            });
            updatedInput.cantidad = 0;
          } else {
            updatedInput.idProporcion = inventario.idProporcion;

            if (updatedInput.cantidad > inventario.cantidad) {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: `La cantidad excede tu inventario de ${inventario.cantidad}`,
                showConfirmButton: false,
              });
            }
          }
        }
      }

      return updatedInput;
    });
  };

  const handleManualAdd = async () => {
    if (
      !manualInput.articulosNombre ||
      !manualInput.idColor ||
      !manualInput.idTalla ||
      !manualInput.cantidad
    ) {
      return;
    }

    const selectedColor = manualInput.colores.find(
      (c) => c._id === manualInput.idColor
    );
    const selectedTalla = manualInput.tallas.find(
      (t) => t._id === manualInput.idTalla
    );

    const inventario = inventarios.find(
      (inv) =>
        inv.idArticulo === manualInput.articulos &&
        inv.color === selectedColor.name &&
        inv.talla === selectedTalla.name
    );

    const cantidadFinal = inventario
      ? Math.min(inventario.cantidad, manualInput.cantidad)
      : manualInput.cantidad;

    if (inventario) {
      const avaible = inputFields.find(
        (i) => i.idArticuloProporcion === inventario.idArticuloProporcion
      );

      if (avaible) {
        // Create new array with updated object
        const updatedFields = inputFields.map((field) => {
          if (field.idArticuloProporcion === inventario.idArticuloProporcion) {
            return {
              ...field,
              cantidad: field.cantidad + manualInput.cantidad,
              total: (field.cantidad + manualInput.cantidad) * field.precio,
            };
          }
          return field;
        });

        setInputFields(updatedFields);
        setTotalCantidad((prevCantidad) => prevCantidad + manualInput.cantidad);
        setManualInput((prev) => ({
          ...prev,
          idColor: "",
          articulos: "",
          articulosNombre: "",
          cantidad: 0,
          idTalla: "",
          tallaNombre: "",
          total: 0,
          idProporcion: "",
        }));

        return null;
      }

      const newField = {
        id: uuidv4(),
        articulos: manualInput.articulos,
        precio: manualInput.precio,
        idInv: inventario._id,
        cantInv: inventario.cantidad,
        articulosNombre: manualInput.articulosNombre,
        idArticuloProporcion: inventario.idArticuloProporcion,

        precioEsp: inventario.precioEsp,
        venta: inventario.venta,
        costoUnitario: inventario.costoUnitario,
        precioOriginal: inventario.venta,
        cantidad: cantidadFinal,
        total: cantidadFinal * manualInput.precio,

        idTalla: manualInput.idTalla,
        tallaNombre: selectedTalla ? selectedTalla.name : "",
        idColor: manualInput.idColor,
        colorNombre: selectedColor ? selectedColor.name : "",
        colores: manualInput.colores,
        tallas: manualInput.tallas,
        cajas: 0,
      };

      setInputFields((prev) => [...prev, newField]);

      // Reset only specific fields after adding
      setManualInput((prev) => ({
        ...prev,
        idColor: "",
        articulos: "",
        articulosNombre: "",
        cantidad: 0,
        idTalla: "",
        tallaNombre: "",
        total: 0,
        precio: 0,
        idProporcion: "",
      }));
    }
  };

  // esEnter: true cuando viene del Enter/Tab del lector (fin de lectura).
  async function buscarArticuloSingular(id, event, esEnter = false) {
    const inputEl = event.target;
    const raw = (inputEl.value || "").trim();
    if (!raw) return;

    // El lector puede mandar el EPC SGTIN-96 (24 hex) o su EAN-13 ya decodificado
    // (13 digitos). Se compara contra el RFID GUARDADO que manda el backend.
    const epcDecoded = epcToEAN13(raw);
    const scanned = epcDecoded || raw;
    const scannedUpper = scanned.toUpperCase();
    const esTagRFID = !!epcDecoded;
    const esLecturaEtiqueta = esTagRFID || validateEAN13(scanned);
    const epc = raw.replace(/\s+/g, "").toUpperCase();

    // Solo se busca cuando la lectura esta COMPLETA.
    //
    // El onChange de este campo dispara con CADA caracter que teclea la pistola,
    // asi que sin esta guarda se evaluaba cada fragmento del codigo ("H", "HS",
    // "HSY"...) contra el inventario. Como la comparacion es igualdad exacta y
    // los EAN viejos (codigo+color+talla) tienen largos distintos, en cuanto un
    // fragmento coincidia con el EAN completo de OTRO articulo, ese articulo se
    // agregaba solo al apartado. De ahi las prendas que nadie escaneo.
    //
    // Completa = EAN-13 valido, EPC de 24 hex, o el Enter/Tab con que la pistola
    // cierra la lectura.
    const lecturaCompleta = esLecturaEtiqueta || /^[0-9A-F]{24}$/i.test(epc) || esEnter;
    if (!lecturaCompleta) return;

    // Mismo tag fisico ya contado (solo el EPC trae numero de serie)
    if (esTagRFID && epcLeidosRef.current.has(epc)) {
      inputEl.value = "";
      setRfidStats((st) => ({ ...st, repetidas: st.repetidas + 1 }));
      return;
    }
    let agregado = null;
    let encontrado = false;
    try {
      inventarios.map((a) => {
        if (
          (a.eanProporcion && a.eanProporcion.toUpperCase() === scannedUpper) ||
          (a.rfid && a.rfid === scanned)
        ) {
          encontrado = true;
          let idArticulo = a.idArticulo;
          let articulosNombre = a.nombre;
          let colores = a.colores;
          let tallas = a.tallas;
          let cantInv = parseFloat(a.cantidad);
          let idInv = a._id;
          let idColor = a.idColor;
          let idTalla = a.idTalla;

          let precio;
          if (listaPrecios == 1) {
            precio = a.lista1;
          } else if (listaPrecios == 2) {
            precio = a.lista2;
          } else if (listaPrecios == 3) {
            precio = a.lista3;
          } else if (listaPrecios == 4) {
            precio = a.lista4;
          }

          const avaible = inputFields.find(
            (i) => i.idArticuloProporcion === a.idArticuloProporcion
          );

          if (avaible) {
            // Create new array with updated object
            const updatedFields = inputFields.map((field) => {
              if (field.idArticuloProporcion === a.idArticuloProporcion) {
                return {
                  ...field,
                  cantidad: field.cantidad + 1,
                  total: (field.cantidad + 1) * field.precio,
                };
              }
              return field;
            });

            agregado = a.idArticuloProporcion;
            setInputFields(updatedFields);
            return null;
          }

          // const avaiable = inputFields.find((i) => {
          //   if (i.articulos === idArticulo) {
          //     Swal.fire({
          //       icon: "error",
          //       title: "Oops...",
          //       text: "El artículo ya ha sido agregado",
          //       showConfirmButton: false,
          //     });
          //     return true;
          //   }
          //   return false;
          // });
          // if (avaiable) {
          //   return;
          // }

          const newField = {
            id: uuidv4(),
            articulos: idArticulo,
            precio: precio,
            idInv: idInv,
            cantInv: 1,
            articulosNombre: articulosNombre,

            precioEsp: a.precioEsp,
            venta: a.venta,
            costoUnitario: a.costoUnitario,
            precioOriginal: a.venta,
            cantidad: 1,
            total: precio,

            idTalla: idTalla,
            tallaNombre: a.talla,
            idColor: idColor,
            colorNombre: a.color,
            colores: a.colores,
            tallas: a.tallas,
            cajas: 0,
            idArticuloProporcion: a.idArticuloProporcion,
          };

          agregado = a.idArticuloProporcion;
          setInputFields((prev) => [...prev, newField]);

          // Reset only specific fields after adding
          setManualInput((prev) => ({
            ...prev,
            idColor: "",
            articulos: "",
            articulosNombre: "",
            cantidad: 0,
            idTalla: "",
            tallaNombre: "",
            total: 0,
            precio: 0,
            idProporcion: "",
          }));
        }
        return null;
      });

      if (encontrado) {
        // Limpia el campo AHORA (sincrono) para el siguiente escaneo
        inputEl.value = "";
        if (esTagRFID && agregado) epcLeidosRef.current.set(epc, agregado);
        if (esLecturaEtiqueta && agregado) {
          setRfidStats((st) => ({ ...st, leidas: st.leidas + 1 }));
        }
      } else {
        // Aqui solo se llega con lectura completa (ver la guarda de arriba), asi
        // que el aviso siempre aplica.
        inputEl.value = "";
        if (esLecturaEtiqueta) {
          setRfidStats((st) => ({ ...st, noEncontradas: st.noEncontradas + 1 }));
        }
        // Siempre toast: el modal se robaba el foco ~2s y la cajera seguia
        // escaneando, asi que la siguiente lectura entraba cortada al campo --
        // justo el fragmento que acababa agregando la prenda equivocada.
        alertaEscaneo(true, {
          icon: "error",
          title: "Artículo no encontrado",
          text: "El código escaneado no tiene existencia en esta tienda.",
          showConfirmButton: false,
          timer: 2000,
        }).then(() => {
          if (rfidScanRef.current) rfidScanRef.current.focus();
        });
      }
    } catch (error) {
      console.log("error", error);
      Swal.fire({
        icon: "error",
        title: "Artículo no encontrado",
        text: "No se encontró ningún artículo con el código proporcionado",
      });
    }
  }

  const saveVenta = async (event) => {
    event.preventDefault();
    if (submittingRef.current) return;
    submittingRef.current = true;
    setValidaBoton(false);
    if (saldo >= 0) {
      if (terminal !== "" && destino !== "") {
        let cantidadIF = inputFields.length;
        let contador = 0;
        let contadorCantidad = 0;

        if (cambiarPrecio === false && user.precio_menor === false) {
          inputFields.map(async (a) => {
            if (a.precioOriginal - 51 < a.precio) {
              return (contador = contador + 1);
            }
          });
        } else {
          contador = inputFields.length;
        }

        inputFields.map(async (a) => {
          if (a.cantidad > 0) {
            return (contadorCantidad = contadorCantidad + 1);
          }
        });

        if (contadorCantidad === cantidadIF) {
          if (contador === cantidadIF) {
            let prefijo;
            if (fiscal === "Si") {
              prefijo = "F";
            } else {
              prefijo = "N";
            }

            if (condPago === "Contado" && saldo > 0) {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "El Pago no coincide con el Total",
              });
              submittingRef.current = false;
              setValidaBoton(true);
            } else {
              // El alta de cliente nuevo ya no existe en Apartados: el cliente
              // debe estar registrado (administracion le registra el anticipo).
              if (vistaCliente || !value?._id) {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Selecciona un cliente registrado",
                });
                submittingRef.current = false;
                setValidaBoton(true);
                return;
              }

              if (bloqueadoPorAnticipo) {
                Swal.fire({
                  icon: "error",
                  title: "Sin anticipo",
                  text: "El cliente no tiene anticipo registrado. Administración debe registrarlo antes de crear el apartado.",
                });
                submittingRef.current = false;
                setValidaBoton(true);
                return;
              }

              if (bloqueadoPorPendiente) {
                Swal.fire({
                  icon: "error",
                  title: "Apartado pendiente",
                  text: apartadoPendiente.mensaje,
                });
                submittingRef.current = false;
                setValidaBoton(true);
                return;
              }

              // Sin esto el apartado se guardaba sin vendedor cuando el cliente
              // no tenia ninguno asignado en su ficha, y la comision no era de
              // nadie. Ahora que hay combo, se exige.
              if (!selectedColaborador || selectedColaborador === "0") {
                Swal.fire({
                  icon: "error",
                  title: "Falta el vendedor",
                  text: "Selecciona el vendedor del apartado.",
                });
                submittingRef.current = false;
                setValidaBoton(true);
                return;
              }

              // Quita campos vacios: el validador del backend rechaza "".
              const limpiar = (obj) =>
                Object.fromEntries(
                  Object.entries(obj).filter(
                    ([, v]) => v !== "" && v !== undefined && v !== null && !Number.isNaN(v)
                  )
                );
              const articles = inputFields
                .filter((a) => a.articulos !== "" && a.cantidad > 0)
                .map((a) =>
                  limpiar({
                    articulos: a.articulos,
                    cantidad: parseFloat(a.cantidad),
                    precio: parseFloat(a.precio),
                    total: parseFloat(a.total),
                    inventarios: a.idInv,
                    costoUnitario: a.costoUnitario,
                    colores: a.idColor,
                    tallas: a.idTalla,
                    articulosProporcion: a.idArticuloProporcion,
                  })
                );

              if (!codigoAgrupadoRef.current) codigoAgrupadoRef.current = uuidv4();

              setModalProgreso(true);
              try {
                // Apartado, prendas y anticipo se guardan en una sola operacion
                // en el servidor: si algo falla no queda nada a medias.
                const { data } = await axios.post(
                  `${URL_VENTAS_TIENDAS}ApartadoCompleto`,
                  {
                    fecha,
                    clientes: value._id,
                    colaboradores: selectedColaborador,
                    total_general: total_general.toFixed(2),
                    observaciones,
                    total_cantidad,
                    paqueterias: idPaqueteria,
                    areas: user.areas,
                    comisionTDC,
                    comisionFlete,
                    subTotal: subTotal.toFixed(2),
                    iva: iva.toFixed(2),
                    impuestos: selectedImpuesto,
                    cond_pago: condPago,
                    fiscal,
                    saldo: saldo.toFixed(2),
                    cortesia: 0,
                    prefijo,
                    consecutivo: 0,
                    entregado: "No",
                    descuento: 0,
                    areaSurtido: selectedArea,
                    esApartado: true,
                    codigoAgrupado: codigoAgrupadoRef.current,
                    articles,
                  },
                  {
                    headers: {
                      Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                    },
                  }
                );
                codigoAgrupadoRef.current = null;

                // Ticket siempre se imprime al crear el apartado.
                PDFOC(data._id, data.consecutivo, prefijo);

                await axios
                  .post(
                    URL_LOGS,
                    {
                      tipo: "Crear Apartado de tienda",
                      detalle: `${value._id} ${total_general}`,
                      user: user.id,
                    },
                    {
                      headers: {
                        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                      },
                    }
                  )
                  .catch((error) => console.log(error));

                localStorage.removeItem(DRAFT_KEY);
                setModalProgreso(false);
                Swal.fire({
                  position: "center",
                  icon: "success",
                  title: "Creado con exito",
                  text: "Por favor no refresques ni cierres la ventana",
                  showConfirmButton: false,
                });
                setTimeout(() => {
                  window.location.reload();
                }, 3000);
              } catch (error) {
                console.log(error);
                // Con respuesta del servidor el apartado NO se creo: la llave se
                // descarta. Sin respuesta (red) se conserva para reintentar sin
                // duplicar.
                if (error.response) codigoAgrupadoRef.current = null;
                setModalProgreso(false);
                Swal.fire({
                  icon: "error",
                  title: "No se creó el apartado",
                  text:
                    error.response?.data?.message ||
                    error.response?.data?.error ||
                    "No hubo respuesta del servidor. Revisa tu conexión e intenta de nuevo.",
                });
                submittingRef.current = false;
                setValidaBoton(true);
              }
            }
          } else {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "No puedes vender $50 menos del precio original",
              showConfirmButton: false,
            });
            submittingRef.current = false;
            setValidaBoton(true);
          }
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Existen Productos sin capturar la cantidad",
            showConfirmButton: false,
          });
          submittingRef.current = false;
          setValidaBoton(true);
        }
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Debes Capturar la Terminal o Destino",
          showConfirmButton: false,
        });
        submittingRef.current = false;
        setValidaBoton(true);
      }
    } else {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "No puedes pagar mas del Saldo",
        showConfirmButton: false,
      });
      submittingRef.current = false;
      setValidaBoton(true);
    }
  };

  async function PDFOC(idPDFOC, consecutivo, prefijo) {
    let LA = inputFields.length * 1.5;
    let largoTotal = LA + 4 + 13;

    let agrupado = inputFields.reduce(function (groups, item) {
      const val = item["articulos"];
      groups[val] = groups[val] || {
        articulos: item.articulos,
        cantidad: 0,
        total: 0,
        cajas: 0,
      };
      groups[val].cantidad += item.cantidad;
      groups[val].articulosNombre = item.articulosNombre;
      groups[val].precio = item.precio;
      groups[val].total += item.total;
      groups[val].cajas += item.cajas;
      return groups;
    }, []);

    let dataAgrupado = Object.values(agrupado);

    const data = dataAgrupado
      .sort((a, b) => (a.articulosNombre > b.articulosNombre ? 1 : -1))
      .map((a) => {
        return [
          a.articulosNombre,
          a.cajas,
          new Intl.NumberFormat("en-US").format(a.cantidad),
          new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            maximumFractionDigits: 2,
          }).format(a.precio),
          new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            maximumFractionDigits: 2,
          }).format(a.total),
        ];
      });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });

    const doc = new jsPDF("p", "cm", [8, largoTotal], true);
    var base64 = await qrcode.toDataURL(idPDFOC); // Corrección: await para qrcode.toDataURL
    var img3 = new Image();
    img3.src = base64;

    var img2 = new Image();
    img2.src = "logoInstitucion.png";

    doc.addImage(img2, "png", 5, 1, 2, 2);

    doc.setFontSize(6).setFont(undefined, "bold");
    doc.text(`${import.meta.env.VITE_NOMBRE_INSTITUCION}`, 0.3, 1);
    doc.text(`Sucursal: ${user.areaName}`, 0.3, 1.3);
    doc.text(`Direccion:${user.areaDireccion}`, 0.3, 1.6);
    doc.text(`Atencion al Cliente: ${user.areaTelefono}`, 0.3, 1.9);

    doc.text(`Fecha: ${fecha} ${hora}`, 0.3, 2.5);
    doc.text(
      `Nota: ${prefijo}-${consecutivo} / Almacen: ${selectedAreaName}`,
      0.3,
      2.8
    );

    let tel;
    let nom;

    if (!vistaCliente) {
      doc.text(`Cliente: ${value.nombre_comercial}`, 0.3, 3.4);
      tel = value.telefono;
      nom = value.nombre_comercial;
    } else {
      doc.text(`Cliente: ${nombre_comercial}`, 0.3, 3.4);
      tel = telefono;
      nom = nombre_comercial;
    }

    doc.text(`Vendedor: ${selectedColaboradorName}`, 0.3, 3.7);

    doc.autoTable({
      head: [["Articulo", "Cajas", "Cant", "Precio", "Total"]],
      body: dataPDFLimpia,
      styles: {
        fontSize: 8,
      },
      startY: 4.3,
      theme: "plain",
      margin: { left: 0.3, right: 0.7 },
      foot: [
        [
          "",
          "",
          { content: "SubTotal", colSpan: 2, styles: { halign: "left" } },
          {
            content: new Intl.NumberFormat("en-US", {
              style: "currency",
              currency: "USD",
              maximumFractionDigits: 2,
            }).format(subTotal),
            colSpan: 2,
          },
        ],
        [
          "",
          "",
          { content: `Comision`, colSpan: 2, styles: { halign: "left" } },
          {
            content: new Intl.NumberFormat("en-US", {
              style: "currency",
              currency: "USD",
              maximumFractionDigits: 2,
            }).format(iva),
            colSpan: 2,
          },
        ],
        [
          "",
          "",
          { content: "Comision TDC", colSpan: 2, styles: { halign: "left" } },
          {
            content: new Intl.NumberFormat("en-US", {
              style: "currency",
              currency: "USD",
              maximumFractionDigits: 2,
            }).format(comisionTDC),
            colSpan: 2,
          },
        ],
        [
          "",
          "",
          { content: "Flete", colSpan: 2, styles: { halign: "left" } },
          {
            content: new Intl.NumberFormat("en-US", {
              style: "currency",
              currency: "USD",
              maximumFractionDigits: 2,
            }).format(comisionFlete),
            colSpan: 2,
          },
        ],
        [
          "",
          "",
          { content: "Total", colSpan: 2, styles: { halign: "left" } },
          {
            content: new Intl.NumberFormat("en-US", {
              style: "currency",
              currency: "USD",
              maximumFractionDigits: 2,
            }).format(total_general),
            colSpan: 2,
          },
        ],
        ["Forma de Pago"],
        ["Efectivo", "TDC", "Transfer"],
        [
          `$${new Intl.NumberFormat("en-US").format(efectivo)}`,
          new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            maximumFractionDigits: 2,
          }).format(tdc),
          new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            maximumFractionDigits: 2,
          }).format(transfer),
        ],
      ],
      showFoot: "lastPage",
      pageBreak: "auto",
      tableWidth: "wrap",
    });

    if (condPago === "Credito") {
      doc.text(
        `Firma: ________________`,
        0.3,
        doc.autoTable.previous.finalY + 0.5
      );
    }

    doc.autoPrint();
    window.open(doc.output("bloburl"), "_blank");

    var att = doc.output("arraybuffer");

    let params = new URLSearchParams({
      number: tel,
      message: `Hola ${nom}, Gracias por confiar en ${import.meta.env.VITE_NOMBRE_INSTITUCION}, estamos para servirle!
      Cualquier duda estamos a tu órdenes!
      Bendiciones que tenga buena venta!`,
      fileName: `Nota-${prefijo}${consecutivo}.pdf`,
      mimetype: "application/pdf",
    });

    axios
      .post(`${URL_WHATSAPP}SendPDFFront?${params.toString()}`, att, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          "Content-Type": "application/octet-stream",
        },
      })
      .then(() => {
        // setTimeout(() => {
        //   window.location.reload();
        // }, 3000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response?.data?.message || error.response?.data?.error || 'Ocurrió un error inesperado'}`,
        });
        console.log(error);
      });
  }

  const handleAddFields = () => {
    setInputFields([
      ...inputFields,
      {
        id: uuidv4(),
        idInv: "",
        cantInv: 0,
        articulos: "",
        articulosNombre: "",
        cantidad: 0,
        precio: 0,
        precioOriginal: 0,
        total: 0,
        precioEsp: "Si",
        venta: 0,
        costoUnitario: 0,
        colores: [],
        tallas: [],
        colorNombre: "",
        tallaNombre: "",
        idColor: "",
        idTalla: "",
        cajas: 0,
      },
    ]);
  };

  // Si un renglon desaparece (se elimino o se limpio la captura), sus tags se
  // liberan para que puedan volver a leerse.
  useEffect(() => {
    const vivos = new Set(inputFields.map((f) => f.idArticuloProporcion));
    epcLeidosRef.current.forEach((v, k) => {
      if (!vivos.has(v)) epcLeidosRef.current.delete(k);
    });
  }, [inputFields]);

  const handleRemoveFields = (id) => {
    const values = [...inputFields];
    values.splice(
      values.findIndex((value) => value.id === id),
      1
    );
    setInputFields(values);

    let totalKG = values.map((c) => parseFloat(c.cantidad));
    let TK = totalKG.reduce((t, total, index) => t + total, 0);
    setTotalCantidad(TK);
    let importes = values.map((c) => parseFloat(c.total));
    let TG = importes.reduce((t, total, index) => t + total, 0);
    setSubTotal(TG);

    if (selectedImpuesto !== 0) {
      setIva((selectedImpuesto * TG) / 100);
    } else {
      setIva(0);
    }

    let totTemp =
      (selectedImpuesto * TG) / 100 +
      TG +
      parseFloat(comisionTDC) +
      parseFloat(comisionFlete);

    setTotalGeneral(totTemp);
    setSaldo(totTemp - efectivo - tdc - transfer);
  };

  const handleChangeInput = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i[event.target.name] = parseFloat(event.target.value);
        let totalParcial = i.cantidad * i.precio;
        i.total = totalParcial;
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  const handleChangeInputCantidad = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        if (i.cantInv >= event.target.value) {
          i.cantidad = event.target.value;
          let totalParcial = i.cantidad * i.precio;
          i.total = totalParcial;
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "La cantidad excede tu inventario!",
            showConfirmButton: false,
          });
          i.cantidad = 0;
        }
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  // Agrega una talla nueva (no presente aun en el carrito) directamente desde
  // la tabla compacta. Copiado de VentasTiendasCreate.jsx (mismas dependencias:
  // tallas, inventarios, articulosUnicos, inputFields, ActualizaTotales).
  const handleCreateNewArticuloTalla = async (idArticulo, idColor, tallaNombre, cantidad, precio, colores) => {
    if (!cantidad || parseFloat(cantidad) <= 0) return;

    const tallaCompleta = tallas.find((t) => t.name === tallaNombre);
    if (!tallaCompleta) return;

    const colorCompleto = colores.find((c) => c._id === idColor);
    if (!colorCompleto) return;

    const inventario = inventarios.find(
      (inv) =>
        inv.idArticulo === idArticulo &&
        inv.color === colorCompleto.name &&
        inv.talla === tallaNombre
    );

    if (!inventario) return;
    if (inventario.cantidad < parseFloat(cantidad)) return;

    const existingItem = inputFields.find(
      (item) => item.idArticuloProporcion === inventario.idArticuloProporcion
    );

    if (existingItem) {
      const newQuantity = existingItem.cantidad + parseFloat(cantidad);
      if (newQuantity > inventario.cantidad) {
        Swal.fire({
          icon: "error",
          title: "Stock insuficiente",
          text: `Solo hay ${inventario.cantidad} disponibles y ya tienes ${existingItem.cantidad} agregados.`,
          showConfirmButton: false,
        });
        return;
      }
      const updatedFields = inputFields.map((field) => {
        if (field.idArticuloProporcion === inventario.idArticuloProporcion) {
          return { ...field, cantidad: newQuantity, total: newQuantity * field.precio };
        }
        return field;
      });
      setInputFields(updatedFields);
      ActualizaTotales(updatedFields);
      return;
    }

    const articuloCompleto = articulosUnicos.find((a) => a.idArticulo === idArticulo);
    if (!articuloCompleto) return;

    const newField = {
      id: uuidv4(),
      articulos: idArticulo,
      precio: precio,
      idInv: inventario._id,
      cantInv: inventario.cantidad,
      articulosNombre: `${articuloCompleto.codigo} ${articuloCompleto.nombre}`,
      precioEsp: inventario.precioEsp,
      venta: inventario.venta,
      costoUnitario: inventario.costoUnitario,
      precioOriginal: inventario.venta,
      cantidad: parseFloat(cantidad),
      total: parseFloat(cantidad) * precio,
      idTalla: tallaCompleta._id,
      tallaNombre: tallaNombre,
      idColor: idColor,
      colorNombre: colorCompleto.name,
      colores: colores,
      tallas: articuloCompleto.tallas || [],
      cajas: 0,
      idArticuloProporcion: inventario.idArticuloProporcion,
    };

    const newFields = [...inputFields, newField];
    setInputFields(newFields);
    ActualizaTotales(newFields);
  };

  function BuscaArticulo(id, selectedArticulo) {
    inventarios.map((a) => {
      if (a.idArticulo === selectedArticulo.idArticulo) {
        let idArticulo = a.idArticulo;
        let precio = a.venta;
        let idInv = a._id;
        let cantInv = a.cantidad;
        let articulosNombre = a.codigo;
        let precioEsp = a.precioEsp;
        let venta = a.venta;
        let costoUnitario = a.costoUnitario;
        let precioOriginal = a.venta;
        let colores = a.colores;
        let tallas = a.tallas;

        setInputArticulos({
          id: uuidv4(),
          articulos: idArticulo,
          articulosNombre: articulosNombre,
          cajas: 0,
          precio: 0,
          colores: colores,
          tallas: tallas,
        });
      }
    });
  }

  const handleChangeInputArticulo = (
    id,
    idArticulo,
    precio,
    idInv,
    cantInv,
    articulosNombre,
    precioEsp,
    venta,
    costoUnitario,
    precioOriginal,
    colores,
    tallas
  ) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i.articulos = idArticulo;
        i.precio = precio;
        i.idInv = idInv;
        i.cantInv = cantInv;
        i.articulosNombre = articulosNombre;

        i.precioEsp = precioEsp;
        i.venta = venta;
        i.costoUnitario = costoUnitario;
        i.precioOriginal = precioOriginal;
        i.cantidad = 0;
        i.total = 0;

        i.colores = colores;
        i.tallas = tallas;

        i.colorNombre = "";
        i.tallaNombre = "";
        i.idColor = "";
        i.idTalla = "";
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
    // handleAddFields();
  };

  function ActualizaTotales() {
    let totalKG = inputFields.map((c) => parseFloat(c.cantidad));
    let TK = totalKG.reduce((t, total, index) => t + total, 0);
    setTotalCantidad(TK);
    let importes = inputFields.map((c) => parseFloat(c.total));
    let TG = importes.reduce((t, total, index) => t + total, 0);
    setSubTotal(TG);

    if (selectedImpuesto !== 0) {
      setIva((selectedImpuesto * TG) / 100);
    } else {
      setIva(0);
    }

    let totTemp =
      (selectedImpuesto * TG) / 100 +
      TG +
      parseFloat(comisionTDC) +
      parseFloat(comisionFlete);

    setTotalGeneral(totTemp);
    setSaldo(totTemp - efectivo - tdc - transfer);
  }

  const options = clientes.map((option) => {
    const junta = option.nombre_comercial + " " + option.codigo;
    const firstLetter = option.nombre_comercial[0].toUpperCase();
    return {
      firstLetter: /[0-9]/.test(firstLetter) ? "0-9" : firstLetter,
      ...option,
      junta,
    };
  });

  function calculaImpuesto(e) {
    setSelectedImpuesto(parseFloat(e));
    if (e !== 0) {
      setIva((e * subTotal) / 100);
    } else {
      setIva(0);
    }
    let totTemp =
      (e * subTotal) / 100 +
      subTotal +
      parseFloat(comisionTDC) +
      parseFloat(comisionFlete);

    setTotalGeneral(totTemp);
    setSaldo(totTemp - efectivo - tdc - transfer);
  }

  function jalaComisionTDC(e) {
    setComisionTDC(parseFloat(e));
    if (selectedImpuesto !== 0) {
      setIva((selectedImpuesto * subTotal) / 100);
    } else {
      setIva(0);
    }
    let totTemp =
      (selectedImpuesto * subTotal) / 100 +
      subTotal +
      parseFloat(e) +
      parseFloat(comisionFlete);

    setTotalGeneral(totTemp);
    setSaldo(totTemp - efectivo - tdc - transfer);
  }

  function jalaComisionFlete(e) {
    setComisionFlete(parseFloat(e));
    if (selectedImpuesto !== 0) {
      setIva((selectedImpuesto * subTotal) / 100);
    } else {
      setIva(0);
    }
    let totTemp =
      (selectedImpuesto * subTotal) / 100 +
      subTotal +
      parseFloat(comisionTDC) +
      parseFloat(e);

    setTotalGeneral(totTemp);
    setSaldo(totTemp - efectivo - tdc - transfer);
  }

  function autorizaCambio() {
    if (password === randomCambiaPrecio) {
      setCambiarPrecio(true);
      toggleCambiaPrecio();
      Swal.fire("Good job!", "Se autorizo con exito", "success");
    } else {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "La contraseña es incorrecta!",
      });
    }
  }

  function solicitarAut() {
    setMailAutEnviado(true);

    axios.post(
      `${URL_WHATSAPP}SendMsg`,
      {
        number: import.meta.env.VITE_TELEFONO_SUPER_ADMIN,
        message: `Hola,
La tienda ${areaUserName} esta solicitando un cambio de precio.
Si lo autorizas proporciona la clave:
${randomCambiaPrecio}`,
      },
      {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      }
    );

    axios
      .post(
        URL_SEND_MAIL,
        {
          subject: "Cambio de Precio",
          email: import.meta.env.VITE_EMAIL_SUPER_ADMIN,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
       <th><img width="${import.meta.env.VITE_TAMANO_LOGO_MAIL}" align="center" src="${import.meta.env.VITE_LINK_SISTEMA}logoInstitucion.png" /></th>
       <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${import.meta.env.VITE_NOMBRE_INSTITUCION}</tr>
       <tbody>
       <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
       <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>La tienda ${areaUserName} esta solicitando un cambio de precio, si lo autorizas proporciona la clave ${randomCambiaPrecio}</tr>
       </tbody>
       <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${import.meta.env.VITE_TELEFONO_INSTITUCION}</tr>
       <tr align="right"><br>Powered by <a href="https://sistemify.com"> <img width="20%" align="center" src="${import.meta.env.VITE_LINK_SISTEMA}Logo-Sistemify-PDF.png" /> </a> </tr>
       </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )

      .then(() => {
        Swal.fire("Good job!", "Enviado con exito", "success");
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response?.data?.message || error.response?.data?.error || 'Ocurrió un error inesperado'}`,
        });
        console.log(error);
      });
  }

  const options2 = articulosUnicos.map((option) => {
    const junta = option.codigo;
    const firstLetter = option.codigo[0].toUpperCase();
    return {
      firstLetter: /[0-9]/.test(firstLetter) ? "0-9" : firstLetter,
      ...option,
      junta,
    };
  });

  // Trae el inventario de un almacen. Va aparte de jalaAlmacen porque al
  // restaurar un borrador hay que volver a cargarlo SIN borrar la cotizacion
  // que se acaba de restaurar.
  function cargarInventarios(idArea) {
    return axios
      .get(`${URL_INVENTARIOS}VentaTienda/${idArea}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allInventarios = res.data;
        setInventarios(allInventarios);
        // Guarda: si el almacen viene sin inventario, res.data[0] truena.
        if (allInventarios.length > 0) setSelectedAreaName(allInventarios[0].area);
        let unicos = allInventarios.filter(
          (value, index, self) =>
            index ===
            self.findIndex(
              (t) => t.idArticulo === value.idArticulo && t.cantidad > 0
            )
        );

        setArticulosUnicos(unicos);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  function jalaAlmacen(e) {
    setSelectedArea(e);
    setInventarios([]);
    setInputFields([]);
    setTotalCantidad(0);
    setTotalGeneral(0);
    setSubTotal(0);
    setIva(0);
    setEfectivo(0);
    setTDC(0);
    setTransfer(0);
    setFechaTransfer("NA");
    setDestino("NA");
    setTerminal("NA");
    setSaldo(0);

    cargarInventarios(e);
  }

  const handleChangeInputProporcion = (id, event) => {
    const newInputArticulos = inputArticulos.map((i) => {
      if (id === i.id) {
        if (event.target.name === "precio") {
          i[event.target.name] = parseFloat(event.target.value);
        } else {
          i[event.target.name] = event.target.value;
        }
      }
      return i;
    });
    setInputArticulos(newInputArticulos);
  };

  function BuscaArticuloProporcion(id, selectedArticulo) {
    inventarios.map((a) => {
      if (a.idArticulo === selectedArticulo.idArticulo) {
        let idArticulo = selectedArticulo.idArticulo;
        let articulosNombre =
          selectedArticulo.codigo + " " + selectedArticulo.nombre;
        let colores = a.colores;
        let tallas = a.tallas;

        let precio;
        if (listaPrecios == 1) {
          precio = a.lista1;
        } else if (listaPrecios == 2) {
          precio = a.lista2;
        } else if (listaPrecios == 3) {
          precio = a.lista3;
        } else if (listaPrecios == 4) {
          precio = a.lista4;
        }

        handleChangeInputArticuloProporcion(
          id,
          idArticulo,
          precio,
          articulosNombre,
          colores,
          tallas
        );
      }
    });
  }

  function BuscaCodigoProporcion(id, idArticulo) {
    if (idArticulo.length > 2) {
      inventarios.map((a) => {
        if (a.ean == idArticulo) {
          let articulosNombre = a.codigo + " " + a.nombre;
          let colores = a.colores;
          let tallas = a.tallas;
          let idArticulo = a.idArticulo;

          let precio;
          if (listaPrecios == 1) {
            precio = a.lista1;
          } else if (listaPrecios == 2) {
            precio = a.lista2;
          } else if (listaPrecios == 3) {
            precio = a.lista3;
          } else if (listaPrecios == 4) {
            precio = a.lista4;
          }

          handleChangeInputArticuloProporcion(
            id,
            idArticulo,
            precio,
            articulosNombre,
            colores,
            tallas
          );
        }
      });
    } else {
      const newInputArticulos = inputArticulos.map((i) => {
        if (id === i.id) {
          i.articulos = idArticulo;
          i.precio = 0;
          i.articulosNombre = "";
          i.cajas = 0;
          i.colores = [];
          i.tallas = [];
        }
        return i;
      });
      setInputArticulos(newInputArticulos);
    }
  }

  const handleChangeInputArticuloProporcion = (
    id,
    idArticulo,
    precio,
    articulosNombre,
    colores,
    tallas
  ) => {
    const newInputArticulos = inputArticulos.map((i) => {
      if (id === i.id) {
        i.articulos = idArticulo;
        i.precio = precio;
        i.articulosNombre = articulosNombre;
        i.cajas = 0;
        i.colores = colores;
        i.tallas = tallas;
      }
      return i;
    });
    setInputArticulos(newInputArticulos);
  };

  function agregarProporcion(
    idArticulo,
    articulosNombre,
    precio,
    cajas,
    colores,
    tallas
  ) {
    if (cajas === 0) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "La cantidad debe ser mayor a 0",
      });
      return;
    }
    axios
      .get(`${URL_ARTICULOS_PROPORCION}Articulos/${idArticulo}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allArticulos = res.data;
        const newInputFields = allArticulos
          .map((i) => {
            // Encuentra el inventario correspondiente
            const inventario = inventarios.find(
              (inv) =>
                inv.idArticulo === i.articulos[0]._id &&
                inv.color === i.colores[0].name &&
                inv.talla === i.tallas[0].name
            );
            const avaiable = inputFields.find((a) => {
              if (a.articulos === inputArticulos[0].articulos) {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "El artículo ya ha sido agregado",
                  showConfirmButton: false,
                });
                return true;
              }
              return false;
            });
            if (avaiable) {
              return null;
            }

            // Calcula la cantidad final basada en la disponibilidad del inventario
            const cantidadFinal = inventario
              ? Math.min(inventario.cantidad, i.cantidad * cajas)
              : i.cantidad * cajas;

            if (inventario) {
              return {
                id: uuidv4(),
                articulos: idArticulo,
                precio: precio,
                idInv: inventario._id,
                cantInv: inventario.cantidad,
                articulosNombre: articulosNombre,

                precioEsp: inventario.precioEsp,
                venta: inventario.venta,
                costoUnitario: inventario.costoUnitario,
                precioOriginal: inventario.venta,
                cantidad: cantidadFinal,
                total: cantidadFinal * precio,

                idTalla: i.tallas[0]._id,
                tallaNombre: i.tallas[0].name,
                idColor: i.colores[0]._id,
                colorNombre: i.colores[0].name,
                colores: colores,
                tallas: tallas,
                cajas: cantidadFinal / inventario.piezasPorCaja,
                idArticuloProporcion: i._id,
              };
            }
            return null;
          })
          .filter((i) => i !== null);

        setInputFields((prevInputFields) => {
          const updatedInputFields = [...prevInputFields, ...newInputFields];

          const tallaOrder = [
            "EECH",
            "ECH",
            "CH",
            "M",
            "G",
            "EG",
            "2EG",
            "3EG",
            "4EG",
            "5EG",
            "6EG",
            "1",
            "2",
            "3",
            "4",
            "5",
            "6",
            "7",
            "8",
            "9",
            "10",
            "11",
            "12",
            "13",
            "14",
            "15",
            "16",
            "17",
            "18",
            "19",
            "20",
            "21",
            "22",
            "23",
            "24",
            "25",
            "26",
            "27",
            "28",
            "29",
            "30",
            "31",
            "32",
            "33",
            "34",
            "35",
            "36",
            "37",
            "38",
            "39",
            "40",
            "41",
            "42",
            "43",
            "44",
            "45",
            "46",
            "47",
            "48",
            "49",
            "50",
            "5/6",
            "7/8",
            "10/12",
            "14/16",
          ];

          const sortedInputFields = updatedInputFields.sort((a, b) => {
            if (a.articulosNombre < b.articulosNombre) return -1;
            if (a.articulosNombre > b.articulosNombre) return 1;

            if (a.colorNombre < b.colorNombre) return -1;
            if (a.colorNombre > b.colorNombre) return 1;

            return (
              tallaOrder.indexOf(a.tallaNombre) -
              tallaOrder.indexOf(b.tallaNombre)
            );
          });

          // Calculate total quantities and amounts
          const totalCantidad = sortedInputFields.reduce(
            (acc, curr) => acc + parseFloat(curr.cantidad),
            0
          );
          const TG = sortedInputFields.reduce(
            (acc, curr) => acc + parseFloat(curr.total),
            0
          );

          // Update state with totals
          setTotalCantidad(totalCantidad);
          setSubTotal(TG);

          if (selectedImpuesto !== 0) {
            setIva((selectedImpuesto * TG) / 100);
          } else {
            setIva(0);
          }

          let totTemp =
            (selectedImpuesto * TG) / 100 +
            TG +
            parseFloat(comisionTDC) +
            parseFloat(comisionFlete);

          setTotalGeneral(totTemp);
          setSaldo(totTemp - efectivo - tdc - transfer);

          return sortedInputFields;
        });

        setInputArticulos([
          {
            id: uuidv4(),
            articulos: "",
            cajas: 0,
            precio: 0,
            articulosNombre: "",
            colores: [],
            tallas: [],
          },
        ]);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  return (
    <>
      <Header />
      <br />
      <br />
      {user.apartados ? (
        <div className="card" style={{ padding: "0 15px 15px 15px", overflowX: "hidden" }}>
          <h3 align="center">Nuevo Apartado</h3>
          <div style={{ textAlign: "center", marginBottom: "10px" }}>
            <span style={{ background: "#e8f4fd", border: "1px solid #90caf9", borderRadius: "6px", padding: "4px 14px", fontSize: "13px", color: "#1565c0" }}>
              Cajero activo: <strong>{user.nombre} {user.apellido}</strong>
            </span>
          </div>
          <Form onSubmit={saveVenta} onKeyDown={(e) => { if (e.key === "Enter") e.preventDefault(); }}>
            <FormGroup className="mb-2" style={{ maxWidth: "260px" }}>
              <Label className="mb-0">Almacén de Entrega</Label>
              <Input
                bsSize="sm"
                type="select"
                value={selectedArea}
                required
                onChange={(e) => {
                  jalaAlmacen(e.target.value);
                }}
              >
                <option value="">Selecciona</option>
                {areas
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((a) => {
                    if (a.esTienda == "Si") {
                      return <option value={a._id}>{a.name}</option>;
                    }
                  })}
              </Input>
            </FormGroup>
            {/* Sin alta de cliente nuevo: un cliente nuevo nunca tiene
                anticipo. Administracion lo registra junto con su anticipo. */}

            {vistaCliente ? (
              <>
                <Row>
                  <Col md={3}>
                    <Label>Nombre Comercial</Label>
                    <Input
                      type="text"
                      style={{ backgroundColor: "yellow" }}
                      placeholder="Nombre Comercial"
                      value={nombre_comercial}
                      required
                      onChange={(e) => {
                        setNombreComercial(e.target.value);
                      }}
                    />
                  </Col>
                  <Col md={3}>
                    <Label>Razon Social</Label>
                    <Input
                      type="text"
                      placeholder="Razon Social"
                      value={razon_social}
                      required
                      onChange={(e) => {
                        setRazonSocial(e.target.value);
                      }}
                    />
                  </Col>
                  <Col md={3}>
                    <Label>RFC</Label>
                    <Input
                      type="text"
                      placeholder="RFC"
                      value={RFC}
                      required
                      onChange={(e) => {
                        setRFC(e.target.value);
                      }}
                    />
                  </Col>
                  <Col md={3}>
                    <Label className="mr-sm-2">Paqueteria</Label>
                    <Input
                      className="col-sm-12"
                      style={{ backgroundColor: "yellow" }}
                      type="select"
                      value={selectedPaqueteria}
                      required
                      onChange={(e) => {
                        setSelectedPaqueteria(e.target.value);
                      }}
                    >
                      <option value="0">Selecciona </option>
                      {paqueterias
                        .sort((a, b) => (a.name > b.name ? 1 : -1))
                        .map((a) => {
                          return <option value={a._id}>{a.name}</option>;
                        })}
                    </Input>
                  </Col>
                </Row>

                <Row>
                  <Col md={6}>
                    <Label>Calle</Label>
                    <Input
                      type="text"
                      placeholder="Calle"
                      value={calle}
                      required
                      onChange={(e) => {
                        setCalle(e.target.value);
                      }}
                    />
                  </Col>
                  <Col md={2}>
                    <Label>No. Ext</Label>
                    <Input
                      type="text"
                      placeholder="No. Ext"
                      value={numero_ext}
                      required
                      onChange={(e) => {
                        setNumeroExt(e.target.value);
                      }}
                    />
                  </Col>
                  <Col md={2}>
                    <Label>No. Int</Label>
                    <Input
                      type="text"
                      placeholder="No. Int"
                      value={numero_int}
                      required
                      onChange={(e) => {
                        setNumeroInt(e.target.value);
                      }}
                    />
                  </Col>
                  <Col md={2}>
                    <Label>Pais</Label>
                    <Input
                      type="text"
                      placeholder="Pais"
                      value={pais}
                      required
                      onChange={(e) => {
                        setPais(e.target.value);
                      }}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col md={3}>
                    <Label>Estado</Label>
                    <Input
                      type="text"
                      placeholder="Estado"
                      value={estado}
                      required
                      onChange={(e) => {
                        setEstado(e.target.value);
                      }}
                    />
                  </Col>
                  <Col md={3}>
                    <Label>Ciudad</Label>
                    <Input
                      type="text"
                      placeholder="Ciudad"
                      value={ciudad}
                      required
                      onChange={(e) => {
                        setCiudad(e.target.value);
                      }}
                    />
                  </Col>
                  <Col md={3}>
                    <Label>Delegacion</Label>
                    <Input
                      type="text"
                      placeholder="Delegacion o Municipio"
                      value={delegacion}
                      required
                      onChange={(e) => {
                        setDelegacion(e.target.value);
                      }}
                    />
                  </Col>
                  <Col md={3}>
                    <Label>Colonia</Label>
                    <Input
                      type="text"
                      placeholder="Colonia"
                      value={colonia}
                      required
                      onChange={(e) => {
                        setColonia(e.target.value);
                      }}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col md={3}>
                    <Label>CP</Label>
                    <Input
                      type="text"
                      placeholder="CP"
                      value={cp}
                      required
                      onChange={(e) => {
                        setCP(e.target.value);
                      }}
                    />
                  </Col>
                  <Col md={3}>
                    <Label>Telefono</Label>
                    <Input
                      type="text"
                      style={{ backgroundColor: "yellow" }}
                      placeholder="Telefono"
                      value={telefono}
                      required
                      onChange={(e) => {
                        setTelefono(e.target.value);
                      }}
                    />
                  </Col>
                  <Col md={3}>
                    <Label>Email</Label>
                    <Input
                      type="email"
                      placeholder="Email"
                      value={email}
                      required
                      onChange={(e) => {
                        setEmail(e.target.value);
                      }}
                    />
                  </Col>
                  <Col md={3}>
                    <Label className="mr-sm-2">Vendedor</Label>
                    <Input
                      style={{ backgroundColor: "yellow" }}
                      className="col-sm-12"
                      type="select"
                      value={selectedVendedorInput}
                      required
                      onChange={(e) => {
                        setSelectedVendedorInput(e.target.value);
                        // OJO: este combo es de la vista de alta de cliente,
                        // que en Apartados ya no se usa -- setVistaCliente no
                        // se llama en ningun lado y el guardar rechaza
                        // vistaCliente. Nunca se renderiza.
                        //
                        // Si algun dia se revive el alta de cliente aqui, este
                        // combo NECESITA su propio estado: comparte el del
                        // select de Vendedor del apartado, y asi el vendedor
                        // que se le asigne al cliente nuevo se le acreditaria
                        // tambien a la nota.
                        setSelectedColaborador(e.target.value.split(",")[0]);
                        setSelectedVendedor(e.target.value.split(",")[0]);
                        setSelectedColaboradorName(
                          e.target.value.split(",")[1]
                        );
                      }}
                    >
                      <option value="0">Selecciona un Vendedor</option>
                      {colaboradores
                        .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
                        .map((a) => {
                          return (
                            <option
                              value={[a._id, a.nombre + " " + a.apellido]}
                            >
                              {a.nombre} {a.apellido}
                            </option>
                          );
                        })}
                    </Input>
                  </Col>
                </Row>

                <Row>
                  <Col md={3}>
                    <Label>Forma de Pago</Label>
                    <Input
                      type="select"
                      placeholder="Forma de Pago"
                      value={forma_pago}
                      required
                      onChange={(e) => {
                        setFormaPago(e.target.value);
                      }}
                    >
                      <option value="0">Forma de Pago</option>
                      <option value="Contado">Contado</option>
                      <option value="Credito">Credito</option>
                    </Input>
                  </Col>

                  <Col md={3}>
                    <Label>Plazo</Label>
                    <Input
                      type="select"
                      placeholder="Plazo"
                      value={plazo}
                      required
                      onChange={(e) => {
                        setPlazo(e.target.value);
                      }}
                    >
                      <option value="">Plazo</option>
                      <option value="0">0</option>
                      <option value="30">30</option>
                      <option value="60">60</option>
                      <option value="90">90</option>
                      <option value="120">120</option>
                      <option value="150">150</option>
                      <option value="180">180</option>
                    </Input>
                  </Col>

                  <Col md={3}>
                    <Label>Reg Fiscal</Label>
                    <Input
                      style={{ backgroundColor: "yellow" }}
                      type="select"
                      placeholder="RegFiscal"
                      value={regFiscal}
                      required
                      onChange={(e) => {
                        setRegFiscal(e.target.value);
                      }}
                    >
                      <option value="">Reg Fiscal</option>
                      <option value="0">0</option>
                      <option value="601">
                        601 General de Ley Personas Morales
                      </option>
                      <option value="603">
                        603 Personas Morales con Fines no Lucrativos
                      </option>
                      <option value="605">
                        605 Sueldos y Salarios e Ingresos Asimilados al Salario
                      </option>
                      <option value="608">608 Demas Ingresos</option>
                      <option value="612">
                        612 Personas Fisicas con Actividad Empresarial
                      </option>
                      <option value="616">616 Sin Obligacion Fiscal</option>
                      <option value="621">621 Incorporacion Fiscal</option>
                      <option value="625">
                        625 Reg. de las act. emp. cpn ingresos a traves de plat.
                        tec.
                      </option>
                      <option value="626">
                        626 Regimen simplificado de Confianza
                      </option>
                    </Input>
                  </Col>
                  <Col md={3}>
                    <Label className="mr-sm-2">Grupo</Label>
                    <Input
                      className="col-sm-12"
                      style={{ backgroundColor: "yellow" }}
                      type="select"
                      value={selectedGrupo}
                      required
                      onChange={(e) => {
                        setSelectedGrupo(e.target.value);
                      }}
                    >
                      <option value="0">Selecciona una Grupo</option>
                      {grupos
                        .sort((a, b) => (a.name > b.name ? 1 : -1))
                        .map((a) => {
                          return <option value={a._id}>{a.name}</option>;
                        })}
                    </Input>
                  </Col>
                </Row>
                <Row>
                  <Col md={3}>
                    <Label className="mr-sm-2">Departamento</Label>
                    <Input
                      className="col-sm-12"
                      style={{ backgroundColor: "yellow" }}
                      type="select"
                      value={selectedDepartamento}
                      required
                      onChange={(e) => {
                        setSelectedDepartamento(e.target.value);
                      }}
                    >
                      <option value="0">Selecciona </option>
                      {departamentos
                        .sort((a, b) => (a.name > b.name ? 1 : -1))
                        .map((a) => {
                          return <option value={a._id}>{a.name}</option>;
                        })}
                    </Input>
                  </Col>

                  <Col md={3}>
                    <Label className="mr-sm-2">Almacen</Label>
                    <Input
                      className="col-sm-12"
                      style={{ backgroundColor: "yellow" }}
                      type="select"
                      value={selectedAreaCliente}
                      required
                      onChange={(e) => {
                        setSelectedAreaCliente(e.target.value);
                      }}
                    >
                      <option value="0">Selecciona</option>
                      {areas
                        .sort((a, b) => (a.name > b.name ? 1 : -1))
                        .map((a) => {
                          if (a.esTienda == "Si") {
                            return <option value={a._id}>{a.name}</option>;
                          }
                        })}
                    </Input>
                  </Col>

                  <Col md={3}>
                    <Label for="exampleEmail" className="mr-sm-2">
                      Observaciones
                    </Label>
                    <Input
                      type="text"
                      placeholder="Observaciones"
                      value={observacionesCliente}
                      required
                      onChange={(e) => {
                        setObservacionesCliente(e.target.value);
                      }}
                    />
                  </Col>
                  <Col md={3}>
                    <Label>Descuento</Label>
                    <Input
                      type="number"
                      placeholder="Descuento"
                      value={descuentoCliente}
                      required
                      onChange={(e) => {
                        setDescuentoCliente(e.target.value);
                      }}
                    />
                  </Col>
                </Row>
                <br />
              </>
            ) : undefined}

            <Row>
              {/* PANEL IZQUIERDO */}
              <Col md={3}>
                {!vistaCliente ? (
                  <>
                    {selectedArea !== "" ? (
                      <FormGroup className="mb-1">
                        <Label className="mb-0">Cliente</Label>
                        <Autocomplete
                          size="small"
                          value={value}
                          onChange={(event, selectedCliente) => {
                            if (selectedCliente) {
                              setValue(selectedCliente);
                              setAlertasCliente(selectedCliente.alertas);
                              setAreaCliente(selectedCliente.areas[0]._id);
                              setListaPrecios(selectedCliente.listaPrecios);
                              // El vendedor del apartado sale del combo: el de
                              // la sesion, o el que hayan elegido a mano. El de
                              // la ficha del cliente quedo como respaldo, solo
                              // para cuando no hay ninguno (quien captura no
                              // esta dado de alta como colaborador).
                              if (!vendedorTocadoRef.current && !selectedVendedor) {
                                aplicaVendedor(selectedCliente.vendedor?.[0]);
                              }
                            }
                          }}
                          options={options.sort((a, b) => -b.firstLetter.localeCompare(a.firstLetter))}
                          groupBy={(option) => option.firstLetter}
                          getOptionLabel={(option) => option?.junta || ""}
                          renderInput={(params) => <TextField {...params} label="Selecciona" variant="outlined" />}
                          renderOption={(props, option) => (
                            <li {...props} key={option._id}>{option.codigo} {option.nombre_comercial}</li>
                          )}
                        />
                      </FormGroup>
                    ) : (
                      <FormGroup className="mb-1">
                        <Label className="mb-0">Cliente</Label>
                        <Autocomplete
                          size="small"
                          value={value}
                          onChange={(event, selectedCliente) => {
                            if (selectedCliente) {
                              setValue(selectedCliente);
                              setAreaCliente(selectedCliente.areas[0]._id);
                              // Igual que arriba: el vendedor de la ficha solo
                              // entra si el combo quedo vacio.
                              if (!vendedorTocadoRef.current && !selectedVendedor) {
                                aplicaVendedor(selectedCliente.vendedor?.[0]);
                              }
                            }
                          }}
                          disabled
                          options={options.sort((a, b) => -b.firstLetter.localeCompare(a.firstLetter))}
                          groupBy={(option) => option.firstLetter}
                          getOptionLabel={(option) => option?.junta || ""}
                          renderInput={(params) => <TextField {...params} label="Selecciona" variant="outlined" />}
                          renderOption={(props, option) => (
                            <li {...props} key={option._id}>{option.codigo} {option.nombre_comercial}</li>
                          )}
                        />
                      </FormGroup>
                    )}
                    {value?._id && (
                      <div className="mb-1" style={{ fontSize: "12px" }}>
                        {anticipoCliente.cargando ? (
                          <span className="text-muted">Revisando anticipo del cliente...</span>
                        ) : anticipoCliente.tieneAnticipo ? (
                          <Badge color="success">Con anticipo</Badge>
                        ) : anticipoCliente.requiereAnticipo ? (
                          <Badge color="danger" style={{ whiteSpace: "normal", textAlign: "left" }}>
                            Sin anticipo: no se puede apartar. Administración debe registrar el anticipo del cliente.
                          </Badge>
                        ) : (
                          <Badge color="secondary">Sin anticipo registrado</Badge>
                        )}
                      </div>
                    )}
                    {value?._id && apartadoPendiente.pendiente && (
                      <div className="mb-1" style={{ fontSize: "12px" }}>
                        <Badge color="danger" style={{ whiteSpace: "normal", textAlign: "left" }}>
                          {apartadoPendiente.mensaje}
                        </Badge>
                      </div>
                    )}

                    <FormGroup className="mb-1">
                      <Label className="mb-0">Vendedor</Label>
                      <Input
                        bsSize="sm"
                        style={{ backgroundColor: "yellow" }}
                        type="select"
                        value={selectedVendedorInput}
                        required
                        onChange={(e) => {
                          vendedorTocadoRef.current = true;
                          const [id, nombre] = e.target.value.split(",");
                          // La opcion "Selecciona un Vendedor" vale "0", que
                          // es truthy: si se deja pasar, el backend intenta
                          // convertir "0" a ObjectId y tira la nota con
                          // "Cast to [ObjectId] failed". Se guarda vacio y lo
                          // detiene la validacion de abajo.
                          const vacio = !id || id === "0";
                          // El texto del combo si conserva el "0" para que se
                          // siga viendo el placeholder.
                          setSelectedVendedorInput(e.target.value);
                          setSelectedVendedor(vacio ? "" : id);
                          // selectedColaborador es el id que se guarda en el
                          // apartado y selectedColaboradorName el nombre que
                          // sale en la cotizacion: los dos tienen que moverse
                          // con el combo o la nota y el papel no coinciden.
                          setSelectedColaborador(vacio ? "" : id);
                          setSelectedColaboradorName(vacio ? "" : nombre);
                        }}
                      >
                        <option value="0">Selecciona un Vendedor</option>
                        {colaboradores
                          .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
                          .map((a) => (
                            <option key={a._id} value={[a._id, a.nombre + " " + a.apellido]}>
                              {a.nombre} {a.apellido}
                            </option>
                          ))}
                      </Input>
                    </FormGroup>

                    <FormGroup className="mb-1">
                      <Row>
                        <Col md={4}>
                          <Label className="mb-0">Almacén</Label>
                          <Input bsSize="sm" type="select" value={areaCliente} required disabled>
                            <option value="">Selecciona</option>
                            {areas.map((a) => <option key={a._id} value={a._id}>{a.name}</option>)}
                          </Input>
                        </Col>
                        <Col md={4}>
                          <Label className="mb-0">Paquetería</Label>
                          <Input
                            bsSize="sm"
                            type="select"
                            value={idPaqueteria}
                            required
                            disabled={selectedArea === ""}
                            onChange={(e) => setIdPaqueteria(e.target.value)}
                          >
                            <option value="0">Selecciona </option>
                            {paqueterias.sort((a, b) => (a.name > b.name ? 1 : -1)).map((a) => (
                              <option key={a._id} value={a._id}>{a.name}</option>
                            ))}
                          </Input>
                        </Col>
                        <Col md={4}>
                          <Label className="mb-0">Lista Precios</Label>
                          <Input
                            bsSize="sm"
                            type="select"
                            value={listaPrecios}
                            onChange={(e) => setListaPrecios(parseInt(e.target.value))}
                          >
                            <option value={1}>Lista 1</option>
                            <option value={2}>Lista 2</option>
                            <option value={3}>Lista 3</option>
                            <option value={4}>Lista 4</option>
                          </Input>
                        </Col>
                      </Row>
                    </FormGroup>
                  </>
                ) : (
                  <p className="text-muted text-uppercase mb-1" style={{ fontSize: "10px", letterSpacing: "1px", fontWeight: 600 }}>Venta</p>
                )}

                <FormGroup className="mb-1">
                  <Row>
                    <Col md={7}>
                      <Label className="mb-0">Observaciones</Label>
                      <Input bsSize="sm" type="text" placeholder="Observaciones" value={observaciones} required onChange={(e) => setObservaciones(e.target.value)} />
                    </Col>
                    <Col md={5}>
                      <Label className="mb-0">&nbsp;</Label>
                      <div>
                        <Button size="sm" color="info" onClick={(e) => toggleCambiaPrecio()}>Cambio Precio</Button>
                      </div>
                    </Col>
                  </Row>
                </FormGroup>

                <hr className="my-2" />
                <p className="text-muted text-uppercase mb-1" style={{ fontSize: "10px", letterSpacing: "1px", fontWeight: 600 }}>Configuración Venta</p>
                <Row form className="mb-1 align-items-end">
                  <Col xs={4}><Label className="mb-0" style={{ fontSize: "11px" }}>Com. TDC</Label><Input bsSize="sm" type="number" min="0" step="any" value={comisionTDC} required onChange={(e) => jalaComisionTDC(e.target.value)} /></Col>
                  <Col xs={4}><Label className="mb-0" style={{ fontSize: "11px" }}>Flete</Label><Input bsSize="sm" type="number" min="0" step="any" value={comisionFlete} required onChange={(e) => jalaComisionFlete(e.target.value)} /></Col>
                  <Col xs={4}><Label className="mb-0" style={{ fontSize: "11px" }}>IVA %</Label><Input bsSize="sm" type="number" min="0" step="any" value={selectedImpuesto} onChange={(e) => calculaImpuesto(e.target.value)} /></Col>
                </Row>

                <hr className="my-2" />
                <p className="text-muted text-uppercase mb-1" style={{ fontSize: "10px", letterSpacing: "1px", fontWeight: 600 }}>Totales</p>
                <div style={{ display: "flex", justifyContent: "space-between", fontSize: "12px" }}><span>Piezas:</span><span>{new Intl.NumberFormat("en-US").format(total_cantidad)}</span></div>
                <div style={{ display: "flex", justifyContent: "space-between", fontSize: "12px" }}><span>Subtotal:</span><span>{new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(subTotal)}</span></div>
                <div style={{ display: "flex", justifyContent: "space-between", fontSize: "12px" }}><span>IVA:</span><span>{new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(iva)}</span></div>
                <div style={{ display: "flex", justifyContent: "space-between", fontSize: "14px" }} className="mt-1"><strong>Total:</strong><strong>{new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(total_general)}</strong></div>

                <hr className="my-2" />
                <p className="text-muted text-uppercase mb-1" style={{ fontSize: "10px", letterSpacing: "1px", fontWeight: 600 }}>Anticipo</p>
                <small className="text-muted d-block mb-2">
                  El apartado se guarda sin cobro. El anticipo lo registra administración y se aplica automáticamente al guardar; los abonos siguientes se registran en Anticipos Tiendas.
                </small>

                <div style={{ marginBottom: "4px" }}>
                  <div style={{ fontSize: "11px", marginBottom: "1px" }}>Saldo</div>
                  <Input bsSize="sm" type="number" min="0" step="any" value={saldo} required disabled />
                </div>

                <hr className="my-2" />
                <div style={{ display: "flex", gap: "6px" }}>
                  {validaBoton && !bloqueadoPorAnticipo && !bloqueadoPorPendiente ? (
                    <Button type="submit" size="sm" className="btn btn-success" style={{ flex: 1 }}>Guardar</Button>
                  ) : (
                    <Button type="submit" size="sm" className="btn btn-success" style={{ flex: 1 }} disabled>Guardar</Button>
                  )}
                  <Button href="/MenuTiendas" size="sm" className="btn btn-danger" style={{ flex: 1 }} id="botonListado">Regresar</Button>
                </div>
              </Col>

              {/* PANEL DERECHO */}
              <Col md={9}>
                <p className="text-muted text-uppercase mb-1 mt-2" style={{ fontSize: "10px", letterSpacing: "1px", fontWeight: 600 }}>Agregar Caja</p>
                <div style={{ display: "flex", alignItems: "flex-end", gap: "8px", flexWrap: "wrap", marginBottom: "10px", fontSize: "12px" }}>
                  <div style={{ minWidth: "120px" }}>
                    <div style={{ fontSize: "11px", marginBottom: "2px" }}>Escanea el QR</div>
                    <Input
                      bsSize="sm"
                      name="articulos"
                      type="string"
                      value={inputArticulos[0]?.articulos}
                      onChange={(event) => {
                        BuscaCodigoProporcion(inputArticulos[0].id, event.target.value);
                      }}
                    />
                  </div>
                  <div style={{ width: "220px" }}>
                    <div style={{ fontSize: "11px", marginBottom: "2px" }}>Selecciona</div>
                    <Autocomplete
                      size="small"
                      value={inputArticulos[0]?.articulosNombre || ""}
                      onChange={(event, selectedArticulo) => {
                        BuscaArticuloProporcion(inputArticulos[0]?.id || "template", selectedArticulo);
                      }}
                      options={options2.sort((a, b) => -b.firstLetter.localeCompare(a.firstLetter))}
                      groupBy={(option) => option.firstLetter}
                      getOptionLabel={(option) => option?.junta || ""}
                      renderInput={(params) => <TextField {...params} label="" variant="outlined" slotProps={{ input: { ...params.InputProps, style: { height: "31px", fontSize: "12px", padding: "0 30px 0 8px" } }, htmlInput: { ...params.inputProps, style: { padding: "0", fontSize: "12px" } } }} />}
                      renderOption={(props, option) => <li {...props} key={option._id}>{option.codigo} {option.nombre}</li>}
                    />
                  </div>
                  <div style={{ flex: 1, minWidth: "120px" }}>
                    <div style={{ fontSize: "11px", marginBottom: "2px" }}>Artículo</div>
                    <Input bsSize="sm" name="articulosNombre" type="string" placeholder="Articulo" value={inputArticulos[0].articulosNombre || ""} disabled style={{ width: "100%" }} />
                  </div>
                  <div style={{ width: "70px" }}>
                    <div style={{ fontSize: "11px", marginBottom: "2px" }}>Cajas</div>
                    <Input bsSize="sm" name="cajas" type="number" min="0" step="any" placeholder="Cajas" value={inputArticulos[0].cajas || ""} onChange={(event) => handleChangeInputProporcion(inputArticulos[0]?.id || "template", event)} />
                  </div>
                  <div style={{ width: "70px" }}>
                    <div style={{ fontSize: "11px", marginBottom: "2px" }}>Precio</div>
                    <Input bsSize="sm" name="precio" type="number" min="0" step="any" placeholder="Precio" value={inputArticulos[0]?.precio || ""} onChange={(event) => handleChangeInputProporcion(inputArticulos[0]?.id || "template", event)} />
                  </div>
                  <div>
                    <Button
                      size="sm"
                      color="success"
                      disabled={!inputArticulos[0]?.articulos || !inputArticulos[0]?.cajas}
                      onClick={() =>
                        agregarProporcion(
                          inputArticulos[0]?.articulos,
                          inputArticulos[0]?.articulosNombre,
                          inputArticulos[0]?.precio,
                          inputArticulos[0]?.cajas,
                          inputArticulos[0]?.colores,
                          inputArticulos[0]?.tallas
                        )
                      }
                      tabindex="-1"
                    >
                      Agregar
                    </Button>
                  </div>
                </div>

                <p className="text-muted text-uppercase mb-1" style={{ fontSize: "10px", letterSpacing: "1px", fontWeight: 600 }}>Agregar Pieza</p>
                <div style={{ display: "flex", alignItems: "flex-end", gap: "8px", flexWrap: "wrap", marginBottom: "8px", fontSize: "12px" }}>
                  <div style={{ minWidth: "120px" }}>
                    <div style={{ fontSize: "11px", marginBottom: "2px" }}>Escanea QR / RFID</div>
                    <Input
                      bsSize="sm"
                      name="idProporcion"
                      type="text"
                      autoComplete="off"
                      innerRef={rfidScanRef}
                      onChange={(event) => {
                        buscarArticuloSingular(manualInput.id, event);
                      }}
                      onKeyDown={(event) => {
                        if (event.key === "Enter" || (event.key === "Tab" && event.target.value.trim())) {
                          event.preventDefault();
                          buscarArticuloSingular(manualInput.id, event, true);
                        }
                      }}
                    />
                    {(rfidStats.leidas > 0 || rfidStats.repetidas > 0 || rfidStats.noEncontradas > 0) && (
                      <small className="text-muted d-block">
                        RFID: {rfidStats.leidas} leídas · {rfidStats.repetidas} repetidas · {rfidStats.noEncontradas} no encontradas
                      </small>
                    )}
                  </div>
                  <div style={{ width: "220px" }}>
                    <div style={{ fontSize: "11px", marginBottom: "2px" }}>Selecciona</div>
                    <Autocomplete
                      size="small"
                      value={manualInput?.articulosNombre || ""}
                      onChange={(event, selectedArticulo) => {
                        handleManualArticuloChange(selectedArticulo);
                      }}
                      options={options2.sort((a, b) => -b.firstLetter.localeCompare(a.firstLetter))}
                      groupBy={(option) => option.firstLetter}
                      getOptionLabel={(option) => option?.junta || ""}
                      renderInput={(params) => <TextField {...params} label="" variant="outlined" slotProps={{ input: { ...params.InputProps, style: { height: "31px", fontSize: "12px", padding: "0 30px 0 8px" } }, htmlInput: { ...params.inputProps, style: { padding: "0", fontSize: "12px" } } }} />}
                      renderOption={(props, option) => <li {...props} key={option._id}>{option.codigo} {option.nombre}</li>}
                    />
                  </div>
                  <div style={{ flex: 1, minWidth: "100px" }}>
                    <div style={{ fontSize: "11px", marginBottom: "2px" }}>Artículo</div>
                    <Input bsSize="sm" type="text" value={manualInput?.articulosNombre || ""} disabled style={{ width: "100%" }} />
                  </div>
                  <div style={{ width: "90px" }}>
                    <div style={{ fontSize: "11px", marginBottom: "2px" }}>Color</div>
                    <Input bsSize="sm" name="idColor" type="select" value={manualInput?.idColor || ""} onChange={handleManualInputChange}>
                      <option value="">Selecciona Color</option>
                      {manualInput?.colores?.map((color) => <option key={color._id} value={color._id}>{color.name}</option>)}
                    </Input>
                  </div>
                  <div style={{ width: "80px" }}>
                    <div style={{ fontSize: "11px", marginBottom: "2px" }}>Talla</div>
                    <Input bsSize="sm" name="idTalla" type="select" value={manualInput.idTalla || ""} onChange={handleManualInputChange}>
                      <option value="">Selecciona Talla</option>
                      {manualInput.tallas && manualInput.tallas.map((talla) => <option key={talla._id} value={talla._id}>{talla.name}</option>)}
                    </Input>
                  </div>
                  <div style={{ width: "65px" }}>
                    <div style={{ fontSize: "11px", marginBottom: "2px" }}>Cantidad</div>
                    <Input bsSize="sm" name="cantidad" type="number" min="0" step="any" placeholder="Cantidad" disabled={!manualInput?.idColor || !manualInput?.idTalla} value={manualInput?.cantidad || 0} onChange={handleManualInputChange} />
                  </div>
                  <div style={{ width: "70px" }}>
                    <div style={{ fontSize: "11px", marginBottom: "2px" }}>Precio</div>
                    <Input bsSize="sm" name="precio" type="number" value={manualInput?.precio || 0} onChange={handleManualInputChange} />
                  </div>
                  <div>
                    <Button
                      size="sm"
                      color="success"
                      onClick={handleManualAdd}
                      disabled={!manualInput?.articulosNombre || !manualInput?.idColor || !manualInput?.idTalla || !manualInput?.cantidad}
                      tabindex="-1"
                    >
                      Agregar
                    </Button>
                  </div>
                </div>

                <hr style={{ margin: "8px 0" }} />

                {/* ── TABLA DE ARTÍCULOS (compacta, sin expand/collapse) ── */}
                {inputFields.filter((f) => f.articulosNombre && f.articulos).length > 0 && (
                  <table style={{ width: "100%", fontSize: "12px", borderCollapse: "collapse" }}>
                    <thead>
                      <tr style={{ background: "#f1f3f5", borderBottom: "2px solid #dee2e6" }}>
                        <th style={{ padding: "5px 8px", fontWeight: 600 }}>Artículo</th>
                        <th style={{ padding: "5px 6px", fontWeight: 600 }}>Color</th>
                        <th style={{ padding: "5px 6px", fontWeight: 600 }}>Tallas / Cant.</th>
                        <th style={{ padding: "5px 6px", fontWeight: 600, textAlign: "center", width: "50px" }}>Piezas</th>
                        <th style={{ padding: "5px 6px", fontWeight: 600, textAlign: "right", width: "65px" }}>Precio</th>
                        <th style={{ padding: "5px 6px", fontWeight: 600, textAlign: "right", width: "75px" }}>Total</th>
                        <th style={{ width: "28px" }}></th>
                      </tr>
                    </thead>
                    <tbody>
                      {Object.entries(
                        inputFields
                          .filter((f) => f.articulosNombre && f.articulos)
                          .reduce((acc, field) => {
                            const key = field.articulosNombre;
                            if (!acc[key]) {
                              acc[key] = {
                                articuloInfo: {
                                  articulosNombre: field.articulosNombre,
                                  articulos: field.articulos,
                                  availableTallas: Array.from(new Set(
                                    inputFields
                                      .filter((f) => f.articulosNombre === field.articulosNombre)
                                      .map((f) => f.tallaNombre)
                                      .filter(Boolean)
                                      .sort((a, b) => customSizeOrder.indexOf(a) - customSizeOrder.indexOf(b))
                                  )),
                                },
                                colorGroups: [],
                              };
                            }
                            const existingColorIndex = acc[key].colorGroups.findIndex((item) => item.idColor === field.idColor);
                            if (existingColorIndex === -1) {
                              acc[key].colorGroups.push({
                                id: field.id,
                                articulos: field.articulos,
                                articulosNombre: field.articulosNombre,
                                idColor: field.idColor,
                                colorNombre: field.colorNombre,
                                colores: field.colores,
                                precioOriginal: field.precioOriginal,
                                precio: field.precio,
                                quantities: { [field.tallaNombre]: { cantidad: field.cantidad, id: field.id, cantInv: field.cantInv } },
                                total: field.cantidad * field.precio,
                              });
                            } else {
                              if (acc[key].colorGroups[existingColorIndex].quantities[field.tallaNombre]) {
                                acc[key].colorGroups[existingColorIndex].quantities[field.tallaNombre].cantidad += field.cantidad;
                              } else {
                                acc[key].colorGroups[existingColorIndex].quantities[field.tallaNombre] = { cantidad: field.cantidad, id: field.id, cantInv: field.cantInv };
                              }
                              acc[key].colorGroups[existingColorIndex].total += field.cantidad * field.precio;
                            }
                            return acc;
                          }, {})
                      ).flatMap(([articuloNombre, { articuloInfo, colorGroups }]) =>
                        colorGroups.map((group, groupIdx) => (
                          <tr key={`${group.id}-${group.idColor}`} style={{ borderBottom: "1px solid #f0f0f0", background: groupIdx % 2 === 0 ? "#fff" : "#fafafa" }}>
                            <td style={{ padding: "5px 8px", maxWidth: "180px" }}>
                              <div style={{ fontWeight: 600, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }} title={group.articulosNombre}>
                                {group.articulosNombre}
                              </div>
                            </td>
                            <td style={{ padding: "5px 6px", whiteSpace: "nowrap", color: "#555" }}>{group.colorNombre}</td>
                            <td style={{ padding: "4px 6px" }}>
                              <div style={{ display: "flex", flexWrap: "wrap", gap: "4px" }}>
                                {Object.keys(group.quantities).sort((a, b) => customSizeOrder.indexOf(a) - customSizeOrder.indexOf(b)).map((talla) => (
                                  <div key={talla} style={{ textAlign: "center" }}>
                                    <div style={{ fontSize: "10px", color: "#888", lineHeight: 1 }}>{talla}</div>
                                    <div style={{ display: "flex", alignItems: "center", gap: "2px" }}>
                                      <input
                                        type="number"
                                        min="0"
                                        step="1"
                                        value={group.quantities[talla]?.cantidad || 0}
                                        onChange={(e) => {
                                          if (group.quantities[talla]?.id) {
                                            handleChangeInputCantidad(group.quantities[talla].id, e);
                                          } else {
                                            handleCreateNewArticuloTalla(group.articulos, group.idColor, talla, e.target.value, group.precio, group.colores);
                                          }
                                        }}
                                        style={{ width: "34px", fontSize: "12px", padding: "1px 2px", border: `1px solid ${parseFloat(group.quantities[talla]?.cantidad) === 0 ? "#e74c3c" : "#ccc"}`, borderRadius: "3px", textAlign: "center", backgroundColor: parseFloat(group.quantities[talla]?.cantidad) === 0 ? "#ffeaea" : "white" }}
                                      />
                                      <button
                                        type="button"
                                        onClick={() => handleRemoveFields(group.quantities[talla].id)}
                                        style={{ background: "#e74c3c", color: "white", border: "none", borderRadius: "3px", width: "20px", height: "20px", cursor: "pointer", fontSize: "12px", lineHeight: "20px", padding: 0, flexShrink: 0, display: "flex", alignItems: "center", justifyContent: "center" }}
                                      >×</button>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </td>
                            <td style={{ padding: "4px 6px", textAlign: "center" }}>
                              <span style={{ display: "inline-block", background: "#e8f4fd", color: "#1a73e8", fontWeight: 600, fontSize: "12px", borderRadius: "4px", padding: "2px 6px", minWidth: "28px" }}>
                                {Object.values(group.quantities).reduce((sum, q) => sum + (parseFloat(q.cantidad) || 0), 0)}
                              </span>
                            </td>
                            <td style={{ padding: "4px 6px", textAlign: "right" }}>
                              <input
                                type="number"
                                min="0"
                                step="any"
                                name="precio"
                                value={group.precio}
                                onChange={(e) => handleChangeInput(group.id, e)}
                                required
                                style={{ width: "58px", fontSize: "12px", padding: "2px 4px", border: `1px solid ${group.precioOriginal - 50 > group.precio ? "#e74c3c" : "#ccc"}`, borderRadius: "3px", textAlign: "right", backgroundColor: group.precioOriginal - 50 > group.precio ? "#ffeaea" : "white" }}
                              />
                            </td>
                            <td style={{ padding: "5px 8px", textAlign: "right", fontWeight: 600, whiteSpace: "nowrap" }}>
                              ${group.total.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                            </td>
                            <td style={{ padding: "4px", textAlign: "center" }}>
                              <button type="button" onClick={() => handleRemoveFields(group.id)} style={{ background: "#e74c3c", color: "white", border: "none", borderRadius: "3px", width: "22px", height: "22px", cursor: "pointer", fontSize: "14px", lineHeight: 1 }}>×</button>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                )}
              </Col>
            </Row>
          </Form>
          <br />
          <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
            <ModalHeader toggle={toggleProgreso}>
              <h4>Progreso</h4>
            </ModalHeader>
            <ModalBody>
              <h4>
                {" "}
                Este proceso puede tardar varios segundos.
                <br />
                Por favor no cierre ni refresque su navegador.
              </h4>
              <br />
              <div className="progreso">
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
              </div>
            </ModalBody>
          </Modal>

          <Modal
            size="sm"
            isOpen={modalCambiaPrecio}
            toggle={toggleCambiaPrecio}
          >
            <ModalHeader toggle={toggleCambiaPrecio}>
              <h4>Autorizar Precio</h4>
            </ModalHeader>
            <ModalBody>
              {mailAutEnviado === false ? (
                <Col>
                  <Button
                    type="submit"
                    className="btn btn-success"
                    onClick={(e) => solicitarAut()}
                  >
                    Solicitar Autorizacion
                  </Button>
                </Col>
              ) : (
                <>
                  <Input
                    bsSize="sm"
                    type="password"
                    placeholder="Password"
                    value={password}
                    required
                    onChange={(event) => setPassword(event.target.value)}
                  />
                  <br />
                  <Row>
                    <Col>
                      <Button
                        type="submit"
                        className="btn btn-success"
                        onClick={(e) => autorizaCambio()}
                      >
                        Autorizar
                      </Button>
                    </Col>

                    <Col>
                      <Button
                        type="submit"
                        className="btn btn-success"
                        onClick={(e) => solicitarAut()}
                      >
                        Reenviar Solicitud
                      </Button>
                    </Col>
                  </Row>
                </>
              )}
            </ModalBody>
          </Modal>
        </div>
      ) : undefined}
    </>
  );
}

export default ApartadosTiendasCreate;
